<template>

  <div v-if="pageSensor != null && isLoginUserItemReadable(this.pageSensor)">

    <sensorTabs :current="'grid'" :pageSensor="pageSensor" :pageDevice="pageDevice" :pageUser="pageUser">
      <b-button type="button" variant="warning" class="float-right tabButton" size="sm" v-if="showUpdateButton">
        <b-spinner small type="grow" class="mr-0"></b-spinner>
        새 데이터 반영중
      </b-button>

      <b-button type="button" variant="info" class="float-right tabButton mr-2" size="sm" @click="copyURL">
        주소복사
      </b-button>
    </sensorTabs>

    <div :class="(isLoginUserItemWritable(this.pageSensor))? 'writable pt-2':'notWritable pt-2'">

      <div v-if="isLoginUserItemWritable(this.pageSensor)">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="this.pageSensor.disabled == true || this.pageDevice.disabled == true">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>

      <div v-if="showEditControl && (this.selectedCount != 0 || this.editedCount != 0 || this.deletedCount != 0) && isLoginUserItemWritable(this.pageSensor) && isEditable" class="menuRow fontSizeDot8 gothic p-0 border border-bottom-0 border-secondary-light" style="grid-template-columns: auto auto;">

        <div style="grid-area: left;" v-if="this.isEditable">

          <div v-if="this.selectedCount != 0" class="gridAreaBorderRight d-inline-block p-1 fontSizeDot8">
            <span class="ml-2 mr-2 align-middle">선택: {{this.selectedCount}} 개</span>
            <b-button variant="secondary" size="sm" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="clearSelection">
              선택 취소
            </b-button>
            <b-button v-if="currentPage==1" variant="secondary" size="sm" class="m-0 mr-2 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="selectAll" v-b-tooltip.hover title="현 페이지 모두 선택">
              현재 모두 선택
            </b-button>
            <b-button variant="primary" size="sm" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="deleteSelection">
              삭제
            </b-button>
          </div>

          <div v-if="this.deletedCount != 0" class="gridAreaBorderRight d-inline-block p-1 fontSizeDot8">
            <span class="ml-2 mr-2 align-middle">삭제: {{this.deletedCount}} 개</span>
            <b-button variant="secondary"  size="sm"  @click="clearDeletion" class="m-0 mr-2 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8">취소</b-button>
          </div>

          <div v-if="this.editedCount != 0" class="gridAreaBorderRight d-inline-block p-1">
            <span class="mr-2 align-middle">수정: {{this.editedCount}} 개</span>
            <b-button variant="secondary" size="sm" @click="clearEdition" class="m-0 mr-2 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8">취소</b-button>
          </div>

        </div>

        <div v-if="this.changedCount != 0 && this.isEditable" style="grid-area: right;" class="text-right fontSizeDot8">
          <div class="gridAreaBorderLeft d-inline-block p-1 fontSizeDot8">
            <span class="ml-1 mr-1 align-middle">
              수정: {{this.editedCount}} 개,
              삭제: {{this.deletedCount}} 개
            </span>
            <b-button class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot8" @click="applyChanged" :disabled="!this.pageBinded || this.pageSensor.disabled == true || this.pageDevice.disabled == true" v-b-tooltip.hover title="수정 삭제를 서버에 반영함" variant="danger" size="sm">저장하기</b-button>
          </div>
        </div>
      </div>

      <div v-if="showScopeControl" class="border border-bottom-0 border-secondary-light m-0 p-1 fontSizeDot8">
        <b-form @submit.stop.prevent class="was-validated">

          <b-button class="m-0 ml-1 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="previousScopeFromId" :disabled="sliderShow || scopeFromId <= 0 || scopeFromId == null" :title="(sliderShow || scopeFromId <= 0 || scopeFromId == null)? '': '이전'">
            &cularr;
          </b-button>

          <b-form-input v-touch:swipe.stop :number="true" v-model="scopeFromId" id="scopeFromId" type="number" required :min="0" :max="Math.min(sensorRowCount-1-1, scopeToId-1)" trim size="sm" class="pt-dot1 pr-dot1 pb-dot1 pl-dot1 d-inline-block border-secondary m-0 mr-dot1 fontSizeDot8 text-right" style="width: 4.5rem; height: 1.6rem; vertical-align: -1px; background-position: left calc(0.1rem) center !important;" v-b-tooltip.hover :title="scopeFromIdDateStr" :disabled="sliderShow" @change="scopeFromIdChanged"/>

          <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="nextScopeFromId" :disabled="sliderShow || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || scopeFromId == null || (scopeFromIdStart+1000) >= scopeToId" :title="(sliderShow || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || scopeFromId == null || (scopeFromIdStart+1000) >= scopeToId)?'':'다음'">
            &curarr;
          </b-button>

          <b-button class="m-0 p-dot1 fontSizeDot8 d-inline-block" :variant="(scopeFromDateSelected)?'primary':'secondary'" size="sm" style="height: 1.6rem; width: 1.5rem;" @click="focusElement('scopeFromDate');" v-b-tooltip.hover :title="scopeFromDateStr" :disabled="sliderShow">
            &#128336;
          </b-button>

          <datetime v-model="scopeFromDate" ref="scopeFromDate" input-id="scopeFromDate" type="datetime" :min-datetime="minFromDate" :max-datetime="maxFromDate" class="d-inline-block m-0 p-0" style="width: 0.5rem; height: 0.5rem;" input-class="m-0 p-0" input-style="width:1px; height: 10px; font-size: 1px; display: inline-block; opacity: 0;"	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="scopeFromDateInput" :disabled="sliderShow"></datetime>

          <span class="m-0 font-weight-bold d-inline-block">
            ~
          </span>

          <datetime v-model="scopeToDate" ref="scopeToDate" input-id="scopeToDate" type="datetime" :min-datetime="minToDate" :max-datetime="maxToDate" class="d-inline-block m-0 p-0" style="width: 0.5rem;" input-class="m-0 p-0" input-style="width:1px; height: 10px; font-size: 1px; display: inline-block; opacity: 0;"	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="scopeToDateInput" :disabled="sliderShow"></datetime>

          <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="previusScopeToId" :disabled="sliderShow || scopeToId <= 0 || scopeToId == null || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || (scopeToId-1000)<= scopeFromId" :title="(sliderShow || scopeToId <= 0 || scopeToId == null || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || (scopeToId-1000)<= scopeFromId)? '':'이전'">
            &cularr;
          </b-button>

          <b-form-input v-touch:swipe.stop :number="true" v-model="scopeToId" id="scopeToId" trim type="number" required :min="scopeFromId*1+1" :max="sensorRowCount-1" size="sm" class="pt-dot1 pr-dot1 pb-dot1 pl-dot1 d-inline-block border-secondary m-0 mr-dot1 fontSizeDot8 text-right" style="width: 4.5rem; height: 1.6rem; vertical-align: -1px; background-position: left calc(0.1rem) center !important;" v-b-tooltip.hover :title="scopeToIdDateStr" :disabled="sliderShow" @change="scopeToIdChanged"/>

          <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="nextScopeToId" :disabled="sliderShow || scopeToId >= (sensorRowCount-1) || scopeToId == null"  :title="(sliderShow || scopeToId >= (sensorRowCount-1) || scopeToId == null)?'':'다음'">
            &curarr;
          </b-button>

          <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block" :variant="(scopeToDateSelected)?'primary':'secondary'" size="sm" style="height: 1.6rem; width: 1.5rem;" @click="focusElement('scopeToDate')" v-b-tooltip.hover :title="scopeToDateStr" :disabled="sliderShow">
            &#128336;
          </b-button>

          <b-button :disabled="pageSensor.lastBook >= 200 || pageSensor.lastBook < 2" class="m-0 ml-dot1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="toggleSliderShow" v-b-tooltip.hover :title="(sliderShow)? '범위 슬라이드 닫기':'범위 슬라이드 열기'">
            <span v-if="sliderShow">&wedgeq;</span>
            <span v-else>&veeeq;</span>
          </b-button>

          <b-button :disabled="scopeFromIdBook == 0" class="m-0 ml-1 p-dot1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="moveScopeLeft" v-b-tooltip.hover title="범위 왼쪽으로 이동">&lt;</b-button>

          <b-button :disabled="scopeToIdBook == pageSensor.lastBook" class="m-0 ml-1 p-dot1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="moveScopeRight" v-b-tooltip.hover title="범위 오른쪽으로 이동">&gt;</b-button>

          <b-button v-if="dataUpdateNeeded && gridReady" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 d-inline-block float-right fontSizeDot8" style="height: 1.6rem;" variant="secondary" size="sm" @click="cancelScopeChanged" v-b-tooltip.hover title="변경된 범위를 취소">
            취소
          </b-button>

          <b-button v-if="dataUpdateNeeded" id="applyScopeChangedButton" class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 d-inline-block float-right fontSizeDot8" style="height: 1.6rem;" variant="danger" size="sm" @click="applyScopeChanged" v-b-tooltip.hover title="변경된 범위를 적용">
            적용
          </b-button>
        </b-form>
      </div>

      <div v-if="showScopeControl && sliderShow && pageSensor.lastBook < 200" v-touch:swipe.stop class="gothic mt-0 border border-bottom-0 border-secondary-light bg-secondary-lighter" :style="(pageSensor.lastBook < 10)? 'padding: 3rem 2.5rem 1.7rem 2.5rem;clear:both' : 'padding: 0.6rem 1.7rem 1.8rem 1rem;clear:both'">
        <vue-slider v-touch:swipe.stop ref="slider" v-model="sliderValues" :enable-cross="false" :min="-1" :max="this.sensorRowCount-1" :marks="true" :tooltip="(pageSensor.lastBook < 10)?'always':'none'" :dotSize="(pageSensor.lastBook < 10)? 20: 7" style="postion:relative;" :data="sliderStep" absort="true" :lazy="false" @change="checkSliderValues">
          <template v-slot:tooltip="{ value }">
            <div class="dataScopeToolTip">{{ getDateRow(value) }}</div>
          </template>
          <template v-slot:label="{ active, value }">
            <div :class="['vue-slider-mark-label', 'dataScopeSliderMark', {active}]">
              {{ getLabel(value) }}
            </div>
          </template>
        </vue-slider>
      </div>

      <div v-if="showSubControl" class="menuRow fontSizeDot8 gothic mt-0 mb-1 p-0 border border-bottom-1 border-secondary-light rounded-0" style="grid-template-columns: auto 10rem;">

        <div style="grid-area: left;" class="p-0 m-0">

          <div class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <b-button class="pt-dot1 pb-dot1 pl-2 pr-2 m-0 ml-1 mr-1 fontSizeDot8 d-inline-block" variant="primary" size="sm" @click="toggleFilterOn" v-b-tooltip.hover :title="(filterOn)? '필터 닫기':'필터 열기'">필터
              <span v-if="filterOn">끄기</span>
              <span v-else>켜기</span>
            </b-button>
            <b-button class="pt-dot1 pl-1 pr-1 pb-dot1 m-0 fontSizeDot8 d-inline-block" variant="secondary" size="sm"  @click="initFilter" v-if="filterOn==true" v-b-tooltip.hover title="적용된 필터 취소">초기화</b-button>
          </div>

          <div class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <span style="vertical-align : -2px;" class="mr-1 displayNoneMax589">그룹</span>
            <b-form-select size="sm" v-model="groupBy" style="width: 3.3rem; height: 1.6rem; margin-top: 0.4rem" class="p-0 pl-1 pr-2 m-0 mr-1 ml-1 fontSizeDot8 d-inline-block" :options="groupByOptions" @change="checkGroupBy"></b-form-select>
          </div>
          <div class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <b-dropdown v-if="groupBy == 'default'" size="sm" variant="secondary" text="열" toggle-class="pt-dot1 pb-dot1 pl-2 pr-2 m-0 ml-1 mr-1 fontSizeDot8 d-inline-block" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="columns.default" stacked class="p-1 fontSizeDot9" @change="applyColumnsSelected">
                <b-form-checkbox v-for="(item, name) in columnsOptions.default" :key="name" :value="name" size="sm">
                  {{ item.text }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-dropdown>
            <div v-else>
              <div class="d-inline-block" v-for="(value, name) in valuesFiltered" :key="name">
                <b-dropdown size="sm" variant="outline-light" toggle-class="pt-dot1 pb-dot1 pl-1 pr-1 m-0 ml-dot1 mr-dot1 fontSizeDot8 d-inline-block border-secondary rounded-0" :disabled="!gridReady">
                  <template #button-content>
                    <span style="color: black; letter-spacing: -1px;">
                      {{value.title}}
                      <span v-if="columns[groupBy][value.name].length !=0">: </span>
                      <span v-for="(type, index) in columns[groupBy][value.name]" :key="type">
                        <span v-if="index !=0 && index <2" style="letter-spacing: -1px;">, </span>
                        <span v-if="index < 2">
                          {{valueTypeList[type].text}}
                        </span>
                      </span>
                      <span v-if="columns[groupBy][value.name].length > 2">
                        ...
                      </span>
                    </span>
                  </template>
                  <b-form-checkbox-group v-model="columns[groupBy][value.name]" stacked class="p-1 fontSizeDot8" @change="applyColumnsSelected">
                    <b-form-checkbox v-for="(item, name) in columnsOptions[groupBy][value.name]" :key="name" :value="name" size="sm">
                      {{ item.text }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-dropdown>
              </div>

            </div>


          </div>


        </div>
        <div style="grid-area: right;" class="gridAreaBorderLeft text-right p-0 m-0">

          <div class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <b-button :disabled="dataUpdateNeeded || changedCount != 0 || filterUi[groupBy].showSelect != 'all' && typeof(filterUi[groupBy].showSelect) != 'undefined' && groupBy == 'default' || filteredItems.length == 0 && filterOn || gridData.length == 0" class="pt-dot1 pb-dot1 pl-2 pr-2 m-0 mr-1 ml-1 fontSizeDot8 d-inline-block" variant="info" size="sm" v-b-tooltip.hover title="현재 설정으로 데이터 다운로드" @click="showDownloadFloat">
              다운로드
            </b-button>
          </div>

          <div class="d-inline-block p-1">
            <b-form-select size="sm" v-model="perPage" style="width: 3.5rem; height: 1.6rem; margin-top: 0.4rem" class="p-0 pl-1 pr-2 m-0 mr-1 ml-1 fontSizeDot8 d-inline-block" :options="perPageList" v-b-tooltip.hover title="페이지 줄 수"></b-form-select>
          </div>
        </div>
      </div>

      <div class="gothic overflowScrolllMax589">
        <b-table v-touch:swipe.stop striped bordered head-variant="dark" hover :fields="fields[groupBy]" :items="gridData" selectable select-mode="range" selectedVariant="primary" class="dataGrid" :no-sort-reset="false" @row-selected="gridRowSelected" :no-provider-paging="true" :no-provider-sorting="true" :no-provider-filtering="true" :show-empty="true" primary-key="id" :per-page="perPage" :current-page="currentPage" id="sensorGrid" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter-function="gridFilter" :filter="gridFilterOption" @filtered="gridFiltered" :tbody-tr-class="gridRowClass" :busy="gridDisabled || dataUpdateNeeded || !gridReady || fields[groupBy].length == 0" empty-filtered-text="필터 조건에 맞는 데이터가 없습니다." empty-text="데이터가 없습니다.">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner size="sm" type="grow" variant="danger" class="align-middle mr-2" style="width: 1rem; height: 1rem"></b-spinner>
              <span v-if="gridDisabled" class="font-weight-bold fontSizeDot9">
                표가 비활성화 되었습니다.
              </span>
              <span v-else-if="!gridReady" class="font-weight-bold fontSizeDot9">
                데이터 로딩 중입니다.
              </span>
              <span v-else-if="dataUpdateNeeded" class="font-weight-bold fontSizeDot9">
                데이터 업데이트가 필요합니다.
              </span>
              <span v-else-if="fields[groupBy].length == 0" class="font-weight-bold fontSizeDot9">
                선택된 열이 없습니다.
              </span>
              <b-spinner size="sm" type="grow" variant="danger" class="align-middle ml-2" style="width: 1rem; height: 1rem"></b-spinner>
            </div>
          </template>

          <template v-slot:thead-top="data">

            <tr v-if="groupBy == 'default' && gridReady" :class="filterOn ? 'd-table-row': 'd-none'"  id="filterTr">
              <th v-for="item in data.fields" :key="item.name" class="bg-secondary-lighter border-0 rounded-0">
                <div v-if="typeof(item.filter) == 'string'">
                  <div v-if="item.filter == 'selected'" class="mt-1 mb-1"></div>
                  <div v-else-if="item.filter == 'id'" class="mt-1 mb-1">
                    <div class="ml-1 mr-1 mb-1">
                        <b-form-input v-touch:swipe.stop trim type="number" size="sm" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" :number="true" v-model="filterUi[groupBy].idInput" placeholder="숫자" @keydown="doGridRefresh(1000)"></b-form-input>
                    </div>
                    <div class="ml-1 mr-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy].idSelect" :options="numberOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>
                  <div v-else-if="item.filter == 't'" class="mt-1 mb-1">
                    <div :class="(filterUi[groupBy].tInputHidden)? 'ml-1 mr-1 mb-1 d-none': 'ml-1 mr-1 mb-1 d-block'">
                      <datetime v-model="filterUi[groupBy].tInput" input-id="tInput" type="datetime" input-class="m-0 p-0 pl-1 pr-1 fontSizeDot8 form-control form-control-sm" input-style=""	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="applyDatetime"></datetime>
                    </div>
                    <div class="ml-1 mr-1 mb-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy].tSelect" @change="tSelectChanged" :options="dtOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8"></b-form-select>
                    </div>
                  </div>

                  <div v-else-if="item.filter == 'show_details'" class="mt-1 mb-1">
                    <div class="ml-1 mr-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy].showSelect" :options="showOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="item.filter.type == 'boolean'" class="mt-1 mb-1">
                    <div  class="ml-1 mr-1 mb-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy][item.filter.name + 'Select']"  :options="booleanOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>

                  <div v-else class="mt-1 mb-1">
                    <div class="ml-1 mr-1 mb-1">
                        <b-form-input v-touch:swipe.stop trim type="number" size="sm" placeholder="숫자" :number="true" v-model="filterUi[groupBy][item.filter.name + 'Input']" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @keydown="doGridRefresh(1000)"></b-form-input>
                    </div>
                    <div class="ml-1 mr-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy][item.filter.name + 'Select']"  :options="numberOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(1000)"></b-form-select>
                    </div>
                  </div>
                </div>
              </th>
            </tr>

            <tr v-else-if="groupBy != 'default' && gridReady" :class="filterOn ? 'd-table-row': 'd-none'" id="filterTr">
              <th v-for="item in data.fields" :key="item.name" class="bg-secondary-lighter border-0 rounded-0">
                <div v-if="typeof(item.filter) == 'string'">
                  <div v-if="item.filter == 't'" class="mt-1 mb-1">
                    <div class="ml-1 mr-1 mb-1">
                      <datetime v-model="filterUi[groupBy].tInput" input-id="tInput" type="datetime" input-class="m-0 p-0 pl-1 pr-1 fontSizeDot8 form-control form-control-sm" input-style=""	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="applyDatetime"></datetime>
                    </div>
                    <div class="ml-1 mr-1 mb-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy].tSelect" :options="dtOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="item.filter.type == 'boolean'" class="mt-1 mb-1">
                    <div class="ml-1 mr-1 mb-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy][item.filter.name + item.type + 'Select']" :options="booleanOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>
                  <div v-else class="mt-1 mb-1">
                    <div class="ml-1 mr-1 mb-1">
                      <b-form-input v-touch:swipe.stop trim type="number" size="sm" placeholder="숫자" :number="true" v-model="filterUi[groupBy][item.filter.name + item.type + 'Input']" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(1000)"></b-form-input>
                    </div>
                    <div class="ml-1 mr-1">
                      <b-form-select size="sm" v-model="filterUi[groupBy][item.filter.name + item.type + 'Select']"  :options="numberOptions" class="m-0 p-0 pl-1 pr-1 fontSizeDot8" @change="doGridRefresh(10)"></b-form-select>
                    </div>
                  </div>
                </div>
              </th>
            </tr>

          </template>

          <template v-slot:cell(selected)="data" v-if="isLoginUserItemWritable(this.pageSensor)">
            <div class="text-center p-0 pl-1 pr-1">
              <input type="checkbox" v-model="data.item.selected" v-if="data.item.id >= editableMinId && data.item.id <= (rowCount-1) && !data.item.deleted" class="m-0 p-0"/>
            </div>
          </template>

          <template v-slot:cell(show_details)="data" v-if="isLoginUserItemWritable(this.pageSensor)">

            <div v-if="data.item.id >= editableMinId && data.item.id <= (rowCount-1) && data.item.deleted" class="text-center">
              <b-button size="sm" @click="clearDeletionRow(data.item)" variant="outline-secondary" class="fontSizeDot8 m-0 pl-1 pr-1 pt-do1 pb-dot1 d-inline text-black" style="width: 3rem">
                취소
              </b-button>
            </div>

            <div v-else-if="data.item.id >= editableMinId && data.item.id <= (rowCount-1) && data.item.edited" class="text-center">

              <b-button size="sm" @click="data.toggleDetails" variant="outline-secondary"  class="fontSizeDot8 m-0 pl-1 pr-2 pt-do1 pb-dot1 d-inline text-black" style="width: 3rem">
                수정
              </b-button>

              <b-button size="sm" @click="restoreOriginallValues(data.item)" variant="outline-secondary" class="m-0 ml-1 fontSizeDot8 pl-1 pr-1 pt-do1 pb-dot1 d-inline text-black" style="width: 3rem">
                취소
              </b-button>
            </div>

            <div v-else-if="data.item.id >= editableMinId && data.item.id <= (rowCount-1) && !data.item.deleted && !data.item.edited" class="text-center">
              <b-button size="sm" @click="data.toggleDetails" variant="outline-secondary" class="fontSizeDot8 m-0 p-0 d-inline text-black" style="width: 3rem; padding-top: 0.05rem; padding-bottom: 0.05rem;">
                수정
              </b-button>
            </div>

          </template>

          <template slot="row-details" slot-scope="row"  v-if="isLoginUserItemWritable(pageSensor)">
            <b-form @submit.stop.prevent class="was-validated container-fluid m-1 ml-1 mr-1 mb-2">
              <div class="row">
                <div v-for="(value, position) in valuesFiltered" :key="position" class="mr-2 mt-1 mb-1 col">

                  <label v-if="row.item.type=='boolean' || row.item.type=='BOOL_VAL' " :for="'detailsSelect' + row.item.id" class="mb-0 ml-1 mr-2">
                    {{value.name}}
                  </label>
                  <label v-else :for="'detailsInput' + row.item.id" class="mb-0 ml-1 mr-2">
                    {{value.name}}
                  </label>

                  <b-form-input  v-touch:swipe.stop v-if="value.type == 'number' || value.type == 'FLOAT_VAL'" :id="'detailsInput' + row.item.id + '_' + position" size="sm" class="fontSizeDot8 pl-2 pr-2 pt-dot1 pb-dot1 m-0 d-inline-block" style="width: 6rem;" required trim v-model="row.item.data.v[position]" pattern="^-?\d+(\.\d+([Ee][+\-]\d\d?)?)?$"  @keydown="checkOriginalBackup(row.item, position)" @blur="checkEditValue(row.item, position)"/>

                  <b-form-input  v-touch:swipe.stop v-else-if="value.type == 'string'" :id="'detailsInput' + row.item.id + '_' + position" size="sm" class="fontSizeDot8 pl-2 pr-2 pt-dot1 pb-dot1" style="width: 6rem;" type="text" required maxlength="16" minlength="2" trim v-model="row.item.data.v[position]" @keydown="checkOriginalBackup(row.item, position)" @blur="checkEditValue(row.item, position)"/>

                  <b-form-select v-else-if="value.type == 'boolean' || value.type == 'BOOL_VAL'" size="sm" id="'detailsSelect' + row.item.id + '_' + position"  class="fontSizeDot8 pl-2 pr-2 pt-dot1 pb-dot1" style="width: 6rem;" v-model="row.item.data.v[position]" required :options="['true', 'false']" :onclick="checkOriginalBackup(row.item, position)" @change="checkOriginalBackup(row.item, position)"></b-form-select>

                  <b-form-input  v-touch:swipe.stop v-else size="sm" class="fontSizeDot8 pl-2 pr-2 pt-dot1 pb-dot1" style="width: 6rem;" :id="'detailsInput' + row.item.id + '_' + position" required trim v-model="row.item.data.v[position]" pattern="^[-+]?[0-9]*$" @keydown="checkOriginalBackup(row.item, position)" @blur="checkEditValue(row.item, position)"/>

                </div>
                <div  class="mr-2 mt-1 mb-1 col">
                  <b-button @click="row.toggleDetails" class="ml-1 fontSizeDot8 pl-2 pr-2 pt-1 pb-1" size="sm" variant="primary" style="width: 6rem;">닫기</b-button>
                </div>
              </div>
            </b-form>
          </template>
        </b-table>
      </div>

      <div v-if="showPageControl" class="d-flex justify-content-between">
        <div class="gothic mr-1 mb-1 fontSizeDot8 flex-fill pt-1">
          {{this.gridRowCount}} <span class="displayNoneMax589">줄</span>
        </div>
        <div class="gothic mr-1 mb-1 fontSizeDot8 flex-fill">
          <b-pagination v-model="currentPage" :total-rows="gridRowCount" :per-page="perPage" first-text="|‹" last-text="›|" aria-controls="sensorGrid" size="sm" align="center"></b-pagination>
        </div>
        <div class="gothic mr-1 mb-1 fontSizeDot8 flex-fill text-right">
          <b-input size="sm" v-model="currentPage" class="ml-1 d-inline-block fontSizeDot8 pt-dot1 pb-dot1 pl-1 pr-1 mr-1" style="width: 2rem;"></b-input>
          <span class="displayNoneMax589">/ {{ Math.ceil(gridRowCount/perPage) }} 페이지</span>
        </div>
    </div>
  </div>


  <b-modal v-touch:swipe.stop size="lg" id="downloadGridFloat" tabindex="-1" title="데이터 다운로드" static @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

    <p class="fontSizeDot9 gothic" style="line-height: 170%;">
      현재 선택된 그룹, 범위, 열, 필터를 적용한 센서 데이터를 다운로드합니다. 아래 내용을 확인한 후에 다운로드 하시기 바랍니다.
      열 선택 여부와 상관없이 시간은 항상 포함되며, ID는  항상 포함되지 않습니다.
      <span v-if="(groupBy == 'default') && valuesFiltered && !valuesFiltered.every(value=> {
          return this.columns.default.some(column=> {
            return value.name == column;
            })
        }) || groupBy != 'default'" class="text-danger font-weight-bold">
        데이터의 모든 열이 선택되지 않았거나 그룹이 적용되어 다운로드 받은 데이터를 다시 업로드할 수는 없습니다.
      </span>
    </p>

    <b-form @submit.stop.prevent class="was-validated writable">
      <div class="mt-1 gothic gridColumn">
        <div class="gridColumnTitle">
          범위 시작
        </div>
        <div class="gridColumnBody">
          <b>{{this.scopeFromId}}</b> ({{ this.scopeFromIdDateStr }})
        </div>
      </div>
      <div class="mt-1 gothic gridColumn">
        <div class="gridColumnTitle">
          범위 끝
        </div>
        <div class="gridColumnBody">
          <b>{{ this.scopeToId}}</b> ({{ this.scopeToIdDateStr }})
        </div>
      </div>
      <div class="mt-1 gothic gridColumn">
        <div class="gridColumnTitle">
          줄 수
        </div>
        <div class="gridColumnBody">
          {{ this.filteredItems.length }}
        </div>
      </div>
      <div class="mt-1 gothic gridColumn">
        <div class="gridColumnTitle">
          열
        </div>

        <div class="gridColumnBody" v-if="valuesFiltered">
          <span v-if="groupBy == 'default'">
            <span v-for="(field,index) in this.fields.default.filter(item=> {
              return item.key != 'selected' && item.key != 'id' && item.key != 'show_details'
              })" :key="field.key">
              <span v-if="index !=0 ">, </span>
              <span v-if="field.key == 'data.t'">시간</span>
              <span v-else>{{field.label}}</span>
            </span>
          </span>
          <span v-else>
            <span v-for="(field,index) in fields[groupBy].filter(item=> {
              return item.key != 'selected' && item.key != 'id' && item.key != 'show_details'
              })" :key="field.key">
              <span v-if="index !=0 ">, </span>
              <span v-if="field.key == 'data.t'">시간</span>
              <span v-else>{{field.label}}</span>
            </span>
          </span>
        </div>
      </div>

      <div class="mt-1 gothic gridColumn">
        <div class="gridColumnTitle">
          필터
        </div>
        <div class="gridColumnBody">
          <span v-if="!isFiltered">적용안됨</span>

          <ul class="m-0 ml-3 p-0" v-else-if="groupBy == 'default'">

            <li v-if="filterUi[groupBy].tSelect == 'am' || filterUi[groupBy].tSelect == 'pm' || filterUi[groupBy].tSelect == 'day' || filterUi[groupBy].tSelect == 'night'">
              <i>시간: </i>
              {{filterUi[groupBy].tSelect}}
            </li>

            <li v-else-if="filterUi[groupBy].tInput != ''">
              {{this.filterUi[this.groupBy].tSelect}}
              {{this.dateToString(new Date(filterUi[groupBy].tInput))}}
            </li>

            <li v-for="valueName in columns[groupBy].filter(item => {
              if(item=='time' || item == 'show_details' || item == 'selected') return false;
              else if(filterUi[groupBy][item + 'Input'] == '') return false;
              else return true;
              })" :key="valueName">
              <span>
                {{filterUi[groupBy][valueName + 'Input']}}
                {{filterUi[groupBy][valueName + 'Select']}}
                <i>
                  {{fieldsOptions[groupBy][valueName].label}}
                </i>
              </span>
            </li>

          </ul>

          <ul class="m-0 ml-3 p-0" v-else>

            <li v-if="filterUi[groupBy].tSelect == 'am' || filterUi[groupBy].tSelect == 'pm' || filterUi[groupBy].tSelect == 'day' || filterUi[groupBy].tSelect == 'night'">
              <i>시간: </i>
              {{filterUi[groupBy].tSelect}}
            </li>
            <li v-else-if="filterUi[groupBy].tInput != ''">
              {{filterUi[groupBy].tSelect}}
              {{dateToString(new Date(filterUi[groupBy].tInput))}}
            </li>

            <li v-for="field in fields[groupBy].filter(item => {
              if(item.key == '.t') return false;
              else if(item.filter && filterUi[groupBy][item.filter.name + item.type + 'Input'] == '') return false;
              else return true;
              })" :key="field.key">
              {{ filterUi[groupBy][field.filter.name + field.type + "Input"] }}
              {{ filterUi[groupBy][field.filter.name + field.type + "Select"] }}
              {{ field.filter.title }}
            </li>
          </ul>
        </div>
      </div>

      <b-input-group size="sm" class="mt-1">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadFileFormat" style="margin-bottom : 0rem">파일 형식</label>
        </b-input-group-text>
        <b-form-select required id="downloadFileFormat" v-model="downloadFileFormat" :options="[
          {value: '.csv', text: '텍스트 파일'},
          {value: '.json', text: 'JSON 파일'}
        ]" @change="downloadFileExtensionOptionsApply">
        </b-form-select>
      </b-input-group>

      <b-input-group size="sm" class="mt-1">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadFileName" style="margin-bottom : 0rem">파일 이름</label>
        </b-input-group-text>
        <b-form-input v-touch:swipe.stop id="downloadFileName" v-model="downloadFileName" required style="flex-grow:2"/>
        <b-form-select v-model="downloadFileExtension" :options="['.csv', '.txt', '.json']"></b-form-select>
      </b-input-group>

      <b-input-group size="sm" class="mt-1" v-if="downloadFileFormat == '.csv'">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadIncludeHead" style="margin-bottom : 0rem">제목 줄</label>
        </b-input-group-text>
        <b-form-select id="downloadIncludeHead" @change="deleteDownload" required v-model="downloadIncludeHead" :options="[
        {value: true, text: '포함'},
          {value: false, text: '포함 안함'},
        ]">
        </b-form-select>
      </b-input-group>

      <b-input-group size="sm" class="mt-1">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadTimeFormat" style="margin-bottom : 0rem">시간 형식</label>
        </b-input-group-text>
        <b-form-select id="downloadTimeFormat" required v-model="downloadTimeFormat" :options="[
        {value: 'excel', text: '엑셀 맞춤형: 1999-12-31 23:59:59'},
          {value: 'epoch', text: '숫자(유닉스 시간): 1970년 1월 1일 경과 시간(초)'},
          {value: 'dtstr', text: '문자열(ISO8601): 1999-12-31T23:59:59+09:00'},
        ]">
        </b-form-select>
      </b-input-group>

      <b-input-group size="sm" class="mt-1" v-if="downloadFileFormat == '.csv'">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadValueSeperator" style="margin-bottom : 0rem">값 구분자</label>
        </b-input-group-text>
        <b-form-input v-touch:swipe.stop id="downloadValueSeperator" v-model="downloadValueSeperator" required/>
      </b-input-group>

      <b-input-group size="sm" class="mt-1" v-if="downloadFileFormat == '.csv'">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadRowSeperator" style="margin-bottom : 0rem">줄 구분자</label>
        </b-input-group-text>
        <b-form-input  v-touch:swipe.stop id="downloadRowSeperator" v-model="downloadRowSeperator" required/>
      </b-input-group>

      <b-input-group size="sm" class="mt-1" v-if="downloadFileFormat == '.json'">
        <b-input-group-text slot="prepend" class="leftCellTitle">
          <label for="downloadTabAndNewLine" style="margin-bottom : 0rem">공백 형식</label>
        </b-input-group-text>
        <b-form-select id="downloadTabAndNewLine" @change="deleteDownload" required v-model="downloadTabAndNewLine" :options="[
        { value: true, text: '탭과 줄바꿈 있음' },
          { value: false, text: '탭과 줄바꿈 없음' },
        ]">
        </b-form-select>
      </b-input-group>
    </b-form>

    <template slot="modal-footer">

      <b-button v-if="downloadUri" variant="danger" size="sm" :href="downloadUri" :download="downloadFileName + '' + downloadFileExtension" v-b-tooltip.hover title="만든 파일을 다운로드합니다.">
        <span v-if="downloadFileFormat == '.csv'">
          CSV
        </span>
        <span v-else>
          JSON
        </span>
        파일 다운로드 하기
      </b-button>

      <b-button v-if="downloadUri" variant="secondary" size="sm" @click="deleteDownload" v-b-tooltip.hover title="만든 파일을 삭제합니다.">
        <span v-if="downloadFileFormat == '.csv'">
          CSV
        </span>
        <span v-else>
          JSON
        </span>
        파일 삭제하기
      </b-button>

      <b-button v-if="downloadUri==null" variant="outline-secondary" size="sm" @click="makeDownload" :disabled="filteredItems.length == 0">
        <span v-if="downloadFileFormat == '.csv'">
          CSV
        </span>
        <span v-else>
          JSON
        </span>
        파일 만들기
      </b-button>

      <b-button variant="primary" size="sm" @click="hideModal('downloadGridFloat')">
        닫기
      </b-button>
    </template>
  </b-modal>

  </div>
</template>
<script>

import VueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"

import { Datetime } from "vue-datetime"
import { Settings } from "luxon"

import "vue-datetime/dist/vue-datetime.css"

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import eventBus from "@/plugins/eventBus.js";

import { db } from "@/plugins/firebase.js";

import uiUtil from "@/mixins/util.js";
import user from "@/mixins/user.js";

import sensorTabs from "@/components/sensor/sensorTabs.vue";

export default {
  name: "sensorGrid",
  mixins: [uiUtil, user],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageSensor: {
      type: Object,
      default: null
    },
    pageSensorHistory: {
      type: Object,
      default: null
    },
    pageBinded: {
      type: Boolean,
      default: false
    },
    pFromId: { type: Number, default: null },
    pToId: { type: Number, default: null },
    pFromBook: { type: Number, default: null },
    pToBook: { type: Number, default: null },
    pFromDate: { type: String, default: "" },
    pToDate: { type: String, default: "" },
    pFromDateEpoch: { type: Number, default: null },
    pToDateEpoch: { type: Number, default: null },
    pPresentation: { type: Boolean, default: false },
    pEditControl: { type: Boolean, default: true },
    pScopeControl: { type: Boolean, default: true },
    pSubControl: { type: Boolean, default: true },
    pPageControl: { type: Boolean, default: true },
    pHeight: { type: String, default: "" },
    pOverflowY: { type: String, default: "" },
    pGroupBy: { type: String, default: "" },
    pColumns: { type: String, default: "" },
    pPerPage: { type: Number, default: null },
    pCurrent: { type: Number, default: null },
    pSortBy: { type: String, default: "" },
    pSortDesc: { type: Boolean, default: true },
  },

  components: {
    sensorTabs,
    VueSlider,
    Datetime,
    // datePicker,
  },

  data: function() {
    return {

      toastTimer : null,
      blob: null,
      gridDisabled: false,
      gridReady: false,

      showEditControl: true,
      showScopeControl: true,
      showSubControl: true,
      showPageControl: true,

      downloadFileFormat: ".csv",
      downloadFileExtension: ".csv",
      downloadIncludeHead: true,
      downloadTimeFormat: "excel",
      downloadValueSeperator: ",",
      downloadRowSeperator: "\\n",
      downloadTabAndNewLine: true,
      downloadUri: null,

      // columns: [],

      columns: {
        "default": [],
        "hour": {},
        "date": {},
        "month": {},
      },

      columnsOptions: {
        "default": {},
        "hour": {},
        "date": {},
        "month": {},
      },

      fields: {
        "default": [],
        "hour": [],
        "date": [],
        "month": [],
      },

      fieldsOptions: {},

      typeOptions: [
        { value: "average", text: "평균" },
        { value: "median", text: "중앙" },
        { value: "max", text: "최대" },
        { value: "min", text: "최소" },
        { value: "sum", text: "합계" },
        { value: "count", text: "횟수" },
      ],

      valueTypeList: {
        "average": {
          "short": "a",
          "text": "평균",
          "index": 0,
        },
        "median": {
          "short": "m",
          "text": "중간",
          "index": 1,
        },
        "max": {
          "short": "x",
          "text": "최대",
          "index": 2,
        },
        "min": {
          "short": "n",
          "text": "최소",
          "index": 3,
        },
        "sum": {
          "short": "s",
          "text": "합계",
          "index": 4,
        },
        "count": {
          "short": "c",
          "text": "횟수",
          "index": 5,
        },
      },

      isEditable: true,
      isUpdating: false,
      sortBy: "id",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      perPageList: [10, 25, 50, 100, 250, 1000],
      showUpdateButton: false,

      sensorData: [],
      groupByData: {
        "hour": [],
        "date": [],
        "month": []
      },
      groupByDataDirty: false,
      gridData: [],
      lastBook: 0,
      lastIndex: -1,
      bookInfo: null,
      lastValues: null,
      lastValuesModified: null,
      valuesFiltered: [],
      valuesFilteredIndex: {},
      valuesFilteredList: {},

      scopeFromDate: null,
      scopeFromDateSelected: false,
      scopeFromId: null,
      scopeToDate: null,
      scopeToDateSelected: false,
      scopeToId: null,

      scopeSliderShow: false,
      scopeSliderTultips: "always",

      sliderValues: [],
      sliderStep: [],
      sliderShow: false,

      numberOptions: ['<=','<','==','>','>=', '!='],
      dtOptions: [
        { value: "before", text: "이전"},
        { value: "after", text: "이후" },
        { value: "sameDay", text: "같은 날" } ,
        { value: "am", text: "오전" },
        { value: "pm", text: "오후" },
        { value: "day", text: "주간" },
        { value: "night", text: "야간" },
        { value: "around", text: "근처" },
        { value: "aroundTime", text: "시 근처" }
      ],
      showOptions: [
        { value: "all" , text:"모두" },
        { value: "deleted" , text: "삭제됨" },
        { value: "edited" , text: "수정됨" },
        { value: "changed" , text: "변경됨" },
        { value: "unchanged"	, text: "안바뀜" }
      ],
      booleanOptions: [
        { value: "all", text: "모두" },
        { value: "true", text: "true" },
        { value: "false", text: "false" }
      ],
      groupBy: "default",
      groupByOptions: [
        { value: "default", text: "없음" },
        { value: "hour", text: "시" },
        { value: "date", text: "일" },
        { value: "month", text: "월" }
      ],

      filterOn: false,

      filteredItems: [],

      filterUi: {
        "default": {},
        "hour": {},
        "date": {},
        "month": {},
      },
    }
  },
  created: function() {
    Settings.defaultLocale = this.getLang();
  },

  beforeDestroy: function() {
    /*
    this.sensorData = null;
    this.groupByData = null;
    this.gridData = null;
    this.filteredItems = null;
    this.blob = null;
    */
    if(this.groupByDataDirty) {
      this.$set(this.$parent.$parent, "pageSensorHistory", {});
    }
  },

  mounted: function() {
    this.init();
    window.setTimeout(()=> {
      if(this.el("scopeFromDate")) this.el("scopeFromDate").tabIndex = "-1";
      if(this.el("scopeToDate")) this.el("scopeToDate").tabIndex = "-1";
    }, 1000);
  },


  updated: function() {

    if(this.groupBy == "default") {

      if(this.pageDevice.active) {

        // 데이터수는 같은 데 데이터가 달라졌다.
        if(this.rowCount == this.sensorRowCount) {
          if(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime()) {
            if(!this.isUpdating) {

              if(this.toastTimer != null) {
                window.clearTimeout(this.toastTimer);
              }
              this.toastTimer = window.setTimeout(()=> {
                this.$parent.$parent.makeToast("info", "데이터 동기화", "데이터 수는 같은 데 최종 수정일이 달라졌습니다. 화면을 초기화했습니다.", {
                  "autoHideDelay": 5000
                })
              }, 100);
              this.$set(this.$parent.$parent, "pageSensorHistory", {});
              this.$parent.$parent.resetGrid();
            }
          }
        }

        // 데이터가 줄어들었다.
        else if((this.sensorRowCount - this.rowCount) < 0) {
          if(!this.isUpdating) {

            if(this.toastTimer != null) {
              window.clearTimeout(this.toastTimer);
            }
            this.toastTimer = window.setTimeout(()=> {
              this.$parent.$parent.makeToast("info", "데이터 동기화", "서버에 저장된 데이터 수가 현재 데이터 수보다 적습니다. 화면을 초기화했습니다.",{
                "autoHideDelay": 5000
              })
            }, 100);

            this.$set(this.$parent.$parent, "pageSensorHistory", {});
            this.$parent.$parent.resetGrid()
          }
        }

        // 1줄 늘어났다.
        else if((this.sensorRowCount - this.rowCount) == 1) {

          this.showUpdateButton = true

          if(this.scopeToId == (this.rowCount-1)) {
            this.scopeToId = this.sensorRowCount - 1;
            if(this.sliderValues.length == 2) {
              this.$set(this.sliderValues, 1, this.scopeToIdEnd);
            }
            else if(this.sliderValues.length == 0) {
              this.sliderValues.push(this.scopeFromId-1);
              this.sliderValues.push(this.scopeToIdEnd);
            }
          }

          if(this.pageSensor.lastIndex == 0) {
            this.$set(this.$parent.$parent.pageSensorHistory, this.pageSensor.lastBook+ "", {
              dirty: false,
              data: {}
            });
            if(this.sliderStep.length != 0) {
              this.sliderStep.push(this.sensorRowCount-1);
            }
          }
          else {
            if(this.sliderStep.length != 0) {
              this.sliderStep.pop();
              this.sliderStep.push(this.sensorRowCount-1);
            }
          }

          if(typeof(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""]) != "undefined") {
            this.$set(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""].data, this.pageSensor.lastIndex+ "", this.pageSensor.lastValues);
          }

          let toAdd = {
            id: this.sensorRowCount-1,
            selected: false,
            deleted: false,
            edited: false,
            data: this.pageSensor.lastValues
          }

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
          this.lastValues = this.pageSensor.lastValues
          this.bookInfo = this.pageSensor.bookInfo

          if(this.sensorData.length > 0) {
            if(((this.sensorRowCount-1) >= this.sensorData[0].id) && ((this.sensorRowCount-2) <= this.sensorData[this.sensorData.length-1].id)) {
              this.sensorData.push(toAdd);
            }
          }
          else {
            this.sensorData.push(toAdd);
          }

          // if((this.sensorRowCount-1) >= this.scopeFromIdStart && (this.sensorRowCount-1) <= this.scopeToIdEnd ) {
            // this.sensorData.push(toAdd);
            // this.$parent.$parent.resetGrid();
            // this.$set(this.sensorData, this.sensorData.length, toAdd);
          // }

          window.setTimeout(()=>{
            this.showUpdateButton = false
          }, 1500);

          if(this.groupBy == "default") {
            this.sensorGridRefresh();
          }
        }

        // 2줄 이상 늘어났다.
        else if((this.sensorRowCount - this.rowCount) > 1) {

          if(!this.isUpdating) {


            if(this.toastTimer != null) {
              window.clearTimeout(this.toastTimer);
            }
            this.toastTimer = window.setTimeout(()=> {
              this.$parent.$parent.makeToast("info", "데이터 동기화", "한꺼번에 여러 줄의 데이터가 늘어나서 화면을 초기화했습니다.",{
                "autoHideDelay": 5000
              })
            }, 100);

            this.$set(this.$parent.$parent, "pageSensorHistory", {});
            this.$parent.$parent.resetGrid()
          }



          /*
          let toRequest = [];
          for(let i=this.lastBook;i<=this.pageSensor.lastBook;i++) {
            toRequest.push(i);
          }

          if(this.sliderStep.length != 0) {
            if(this.lastBook == this.pageSensor.lastBook) {
              this.sliderStep.pop();
              this.sliderStep.push(this.sensorRowCount-1);
            }
            else {
              this.sliderStep.pop();
              for(let i=(this.lastBook+1);i<=this.pageSensor.lastBook;i++) {
                this.sliderStep.push(i*1000-1);
              }
              this.sliderStep.push(this.sensorRowCount-1);
            }
          }
          */

          /*
          if(this.scopeToId == (this.rowCount-1)) {
            this.scopeToId = this.sensorRowCount - 1;
            if(this.sliderValues.length == 2) this.$set(this.sliderValues, 1, this.scopeToId);
          }
          */


          //this.lastBook = this.pageSensor.lastBook;
          //this.lastIndex = this.pageSensor.lastIndex;
          //this.lastBook = this.pageSensor.lastBook;
          //this.lastIndex = this.pageSensor.lastIndex;
          //this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate();
          //this.lastValues = this.pageSensor.lastValues;
          //this.bookInfo = this.pageSensor.bookInfo;

          /*
          let successCount = 0;
          let endIndex;
          toRequest.forEach((item) => {
            db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
            .get()
            .then(book => {
              if(book.exists) {
                let data = book.data()
                if(item == this.lastBook) {
                  if(typeof(this.$parent.$parent.pageSensorHistory[item]) == "undefined") {
                    this.$parent.$parent.pageSensorHistory[item] = {
                      dirty: false,
                      data: {}
                    }
                  }

                  endIndex = (toRequest.length > 1)? 999: this.countAttributes(data)-2;

                  this.$log.info("item", item);
                  this.$log.info("lastBook", this.lastBook);
                  this.$log.info("lastIndex", this.lastIndex);
                  this.$log.info("endIndex", endIndex);
                  this.$log.info("scopeFromIdStart", this.scopeFromIdStart);
                  this.$log.info("scopeToIdEnd", this.scopeToIdEnd);

                  for(let i=(this.lastIndex+1);i<=endIndex;i++) {

                    this.$parent.$parent.pageSensorHistory[item].data[i] = data[i];

                    if((this.lastBook*1000+i)>=this.scopeFromIdStart && (this.lastbook*1000+i)<=this.scopeToIdEnd) {
                      this.sensorData.push({
                        id: this.lastBook*1000+i,
                        selected: false,
                        deleted: false,
                        edited: false,
                        data: this.$parent.$parent.pageSensorHistory[item].data[i],
                      });
                    }
                  }
                }
                else {
                  this.$parent.$parent.pageSensorHistory[item] = {
                    dirty: false,
                    data: data
                  };
                  endIndex = (item == toRequest[toRequest.length-1])? this.countAttributes(data)-2: 999;

                  this.$log.info("item", item);
                  this.$log.info("lastBook", this.lastBook);
                  this.$log.info("endIndex", endIndex);

                  for(let i=0;i<=endIndex;i++) {
                    if((item*1000+i)>=this.scopeFromIdStart && (item*1000+i)<=this.scopeToIdEnd) {
                      this.sensorData.push({
                        id: item*1000+i,
                        selected: false,
                        deleted: false,
                        edited: false,
                        data: this.$parent.$parent.pageSensorHistory[item].data[i],
                      });
                    }
                  }
                }

                if(++successCount == toRequest.length) {
                  this.$log.info(this.sensorGridRefreshNeeded, this.$parent.$parent.pageSensorHistory, this.sensorData);
                  this.$parent.$parent.resetGrid();
                }
              }
              else {
                if(item == 0) {
                  this.makeToast("info", "데이터 조회중", "데이터가 없습니다.");
                }
                else {
                  this.makeToast("info", "데이터 조회중", item + "번 묶음 데이터가 없습니다.");
                }
              }
            })
            .catch(error=> {
              this.makeToast("danger", "데이터 조회중", "데이터 조회 중 에러가 발생했습니다. 에러 내용: " + error, {
                "noAutoHide": true
              })
            })
          })
          */
        }
      }
      else {
        if(!this.isUpdating) {
          if(
              (this.lastValuesModified == null && this.pageSensor.lastValuesModified != null)||
              (this.lastValuesModified != null && this.pageSensor.lastValuesModified == null)||
              (this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime())
          ) {


            if(this.toastTimer != null) {
              window.clearTimeout(this.toastTimer);
            }
            this.toastTimer = window.setTimeout(()=> {
              this.$parent.$parent.makeToast("danger", "데이터 동기화", "데이터가 수정되어 캐시된 데이터를 초기화합니다.", {
                "autoHideDelay": 5000
              })
            }, 100);




            // this.lastBook = this.pageSensor.lastBook
            // this.lastIndex = this.pageSensor.lastIndex
            // this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
            // this.lastValues = this.pageSensor.lastValues
            // this.bookInfo = this.pageSensor.bookInfo
            this.$set(this.$parent.$parent, "pageSensorHistory", {});
            this.$parent.$parent.resetGrid();
          }
        }
      }

    }
    else {

      this.groupByDataDirty = true;
    }
  },

  methods: {

    copyURL: function() {
      this.$copyText(this.fullURL)
      .then(()=> {
        this.$parent.$parent.makeToast("success", "주소 복사 성공", "주소를 클립보드에 복사했습니다.");
      }, (err) => {
        this.$parent.$parent.makeToast("danger", "주소 복사 실패", "주소를 복사하는 중에 에러가 발생했습니다. error:" + err);
      })
    },

    applyColumnsSelected: function() {
      this.resetfields();
      this.initFilterUi();
    },

    initColumnsOptions: function() {

      this.columnsOptions.default["selected"] = {
        "text": "✓",
      };
      this.columnsOptions.default["id"] = {
        "text": "ID",
      };
      this.columnsOptions.default["time"] = {
        "text": "시간",
        "disabled": true,
      };

      this.valuesFiltered.forEach((value,index)=> {
        this.columnsOptions.default[value.name] = {
          "text": value.title,
          "index": index,
        };
        this.columnsOptions.hour[value.name] = {};
        this.columnsOptions.date[value.name] = {};
        this.columnsOptions.month[value.name] = {};

        this.typeOptions.forEach((type, typeIndex)=> {
          ["hour", "date", "month"].forEach(groupBy => {
            this.columnsOptions[groupBy][value.name][type.value] = {
              "text": type.text,
              "fullText": this.columnsOptions.default[value.name].text + ": " + type.text,
              "index": index,
              "typeIndex": typeIndex,
            };
          });
        });
      });

      if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
        this.columnsOptions.default["show_details"] = {
          text: "수정",
        }
      }
    },

    initColumns: function() {

      /*
      pColumns: { type: String, default: "" },
      */

      if(this.pColumns != "") {
        if(this.groupBy == "default") {
          let pColumns = this.pColumns.split(/[\s+]+/);
          pColumns.forEach(column => {
            if(column == "selected" || column == "show_details") {
              if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
                this.columns.default.push(column);
              }
            }
            else if(column == "id" || column == "time") {
              this.columns.default.push(column);
            }
            else {
              // this.$log.info(column, this.valuesFilteredIndex[column]);
              if(typeof(this.valuesFilteredIndex[column]) != "undefined") {
                this.columns.default.push(column);
                this.columns.hour[column] = [this.typeOptions[0].value];
                this.columns.date[column] = [this.typeOptions[0].value];
                this.columns.month[column] = [this.typeOptions[0].value];
              }
            }
          });

          this.valuesFiltered.forEach(item=> {
            if(typeof(this.columns.hour[item.name]) == "undefined") {
              this.columns.hour[item.name] = [];
              this.columns.date[item.name] = [];
              this.columns.month[item.name] = [];
            }
          })


        }
        else {
          if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
            this.columns.default.push("selected");
          }
          this.columns.default.push("id");
          this.columns.default.push("time");

          let pColumns = this.pColumns.split(/[\s+]+/);

          pColumns.forEach(column=> {
            let splited = column.split(".");
            if(splited.length == 1) {
              splited.push(this.typeOptions[0].value);
            }
            if(splited.length == 2) {
              if(typeof(this.valuesFilteredIndex[splited[0]]) != "undefined" && typeof(this.valueTypeList[splited[1]]) != "undefined") {
                if(splited[1] == "all") {
                  this.columns.hour[splited[0]] = [];
                  this.typeOptions.forEach(item=> {
                    this.columns.hour[splited[0]].push(item.value);
                  });
                }
                else {
                  if(typeof(this.columns.hour[splited[0]]) == "undefined") {
                    this.columns.hour[splited[0]] = [splited[1]];
                    this.columns.date[splited[0]] = [splited[1]];
                    this.columns.month[splited[0]] = [splited[1]];
                  }
                  else {
                    if(!this.columns.hour[splited[0]].some(item => {
                      return item == splited[1]
                    })) {
                      this.columns.hour[splited[0]].push(splited[1]);
                      this.columns.date[splited[0]].push(splited[1]);
                      this.columns.month[splited[0]].push(splited[1]);
                    }
                  }
                }
                if(!this.columns.default.some(item=> {
                  return item == splited[0]
                })) {
                  this.columns.default.push(splited[0]);
                }
              }
            }
          });

          if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
            this.columns.default.push("show_details");
          }
        }
      }
      else {

        if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
          this.columns.default.push("selected");
        }
        this.columns.default.push("id");
        this.columns.default.push("time");

        this.valuesFiltered.forEach((value,index)=> {
          this.columns.default.push(value.name);
          this.columns.hour[value.name] = [this.typeOptions[0].value];
          this.columns.date[value.name] = [this.typeOptions[0].value];
          this.columns.month[value.name] = [this.typeOptions[0].value];
        });

        if(this.isLoginUserItemWritable(this.pageSensor) && this.isEditable) {
          this.columns.default.push("show_details");
        }
      }

      // this.$log.info(this.columns, this.columnsOptions);

    },

    initFieldsOptions: function() {

      this.fieldsOptions.default = {};
      if(this.isLoginUserItemWritable(this.pageSensor)) {
        this.fieldsOptions.default.selected = {
          key: "selected",
          label: '✓',
          filter: "selected",
          tdClass: "selectTd"
        };
        this.fieldsOptions.default.show_details = {
          key: "show_details",
          label: "수정",
          filter: "show_details",
          tdClass: "editTd"
        };
      }
      this.fieldsOptions.default.id = {
        key: "id",
        label: 'ID',
        sortable: true,
        filter: "id",
        tdClass: "idTd",
      }
      this.fieldsOptions.default.time = {
        key: "data.t",
        filter: "t",
        label: "시간",
        sortable: true,
        formatter: value => {
          if(value == null) {
            return "null"
          }
          else {
            return this.dateToString(value.toDate())
          }
        },
        tdClass: "timeTd",
      }


      this.valuesFiltered.forEach((item,index) => {
        this.fieldsOptions.default[item.name] = {
          "label": item.title,
          "sortable": true,
          "filter": item,
          "key": "data.v[" + index + "]",
          "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
        };
      });

      ["date", "hour", "month"].forEach(groupBy => {
        this.fieldsOptions[groupBy] = {};
      });


      this.fieldsOptions["date"].time = {
        key: ".t",
        filter: "t",
        label: "일",
        sortable: true,
        formatter: value => {
          return (value == null)? "null" : this.dateToDateOnlyString(new Date(value*1000));
        },
        tdClass: "timeTd",
      }
      this.fieldsOptions["hour"].time = {
        key: ".t",
        filter: "t",
        label: "시",
        sortable: true,
        formatter: value => {
          return (value == null)? "null" : this.dateToTillHourString(new Date(value*1000));
        },
        tdClass: "timeTd",
      }
      this.fieldsOptions["month"].time = {
        key: ".t",
        filter: "t",
        label: "월",
        sortable: true,
        formatter: value => {
          return (value == null)? "null" : this.dateToTillMonthString(new Date(value*1000));
        },
        tdClass: "timeTd",
      };

      ["date","hour","month"].forEach(groupBy => {
        this.valuesFiltered.forEach((item, index) => {
          this.typeOptions.forEach(type=> {
            if(type.value == "max") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (최대)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.x[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
            else if(type.value == "min") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (최소)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.n[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
            else if(type.value == "average") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (평균)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.a[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
            else if(type.value == "median") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (중간)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.m[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
            else if(type.value == "sum") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (합계)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.s[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
            else if(type.value == "count") {
              this.fieldsOptions[groupBy][item.name + type.value] = {
                "label": item.title + " (횟수)",
                "type": type.value,
                "valueType": this.valueTypeList[type.value].short,
                "sortable": true,
                "filter": item,
                "key": "v.c[" + index + "]",
                "tdClass": (item.type == "boolean" || item.type == "BOOL_VAL")? "booleanTd": "numberTd",
              };
            }
          });
        });
      });

      this.initFields();
    },

    resetfields: function() {
      if(this.groupBy == "default") {
        this.$set(this.fields, "default", []);
        let columnsKeys = {};
        this.columns.default.forEach(item => {
          columnsKeys[item] = true;
        });
        if(columnsKeys["selected"]) {
          this.fields.default.push(this.fieldsOptions[this.groupBy]["selected"]);
        }
        if(columnsKeys["id"]) {
          this.fields.default.push(this.fieldsOptions[this.groupBy]["id"]);
        }
        if(columnsKeys["time"]) {
          this.fields.default.push(this.fieldsOptions[this.groupBy]["time"]);
        }
        this.valuesFiltered.forEach(item => {
          if(columnsKeys[item.name]) {
            this.fields.default.push(this.fieldsOptions[this.groupBy][item.name]);
          }
        });
        if(this.isEditable) {
          if(columnsKeys["show_details"]) {
            this.fields.default.push(this.fieldsOptions[this.groupBy]["show_details"]);
          }
        }
      }
      else {
        this.$set(this.fields, this.groupBy, []);
        this.fields[this.groupBy].push(this.fieldsOptions[this.groupBy].time);
        for(let valueName in this.columns[this.groupBy]) {
          this.columns[this.groupBy][valueName].forEach(type => {
            this.fields[this.groupBy].push(this.fieldsOptions[this.groupBy][valueName+type]);
          });
        }
      }
    },
    initFields: function() {

      this.$set(this.fields, "default", []);
      this.columns.default.forEach((item)=>{
        this.fields.default.push(this.fieldsOptions.default[item]);
      });
      ["hour", "date", "month"].forEach(groupBy => {
        this.$set(this.fields, groupBy, []);
        this.fields[groupBy].push(this.fieldsOptions[groupBy].time);
        for(let valueName in this.columns[groupBy]) {
          this.columns[groupBy][valueName].forEach(type => {
            this.fields[groupBy].push(this.fieldsOptions[groupBy][valueName+type]);
          });
        }
      });
    },

    doGridRefresh: function(ms) {
      if(this.gridRefreshTimer != null) {
        window.clearTimeout(this.gridRefreshTimer);
      }
      this.gridRefreshTimer = window.setTimeout(()=> {
        this.$root.$emit('bv::refresh::table', 'sensorGrid');
        this.gridRefreshTimer = null;
      },ms);
    },

    tSelectChanged: function() {
      if(this.filterUi[this.groupBy].tSelect == "am" || this.filterUi[this.groupBy].tSelect == "pm" || this.filterUi[this.groupBy].tSelect == "day" || this.filterUi[this.groupBy].tSelect == "night") {
         this.filterUi[this.groupBy].tInputHidden = true;
      }
      else {
        this.filterUi[this.groupBy].tInputHidden = false;
      }
      this.doGridRefresh(10);
    },

    checkGroupBy: function() {
      this.gridReady = false;
      if(this.groupBy != "default") {
        this.initFilter();
        if(this.groupByData[this.groupBy].length == 0) {
          this.groupByData[this.groupBy] = this.createGroupByData();
        }
        this.clearAllEdition();
        this.gridData = this.groupByData[this.groupBy];
        if(this.gridData.length !=0) {
          this.$set(this.gridData, this.gridData.length-1, this.gridData[this.gridData.length-1]);
        }
      }
      else {
        if(this.groupByDataDirty) {
          // this.$set(this.$parent.$parent, "pageSensorHistory", {});
          this.$parent.$parent.resetGrid();
        }
        else {
          this.initFilter();
          this.gridData = this.sensorData;
          if(this.gridData.length !=0) {
            this.$set(this.gridData, this.gridData.length-1, this.gridData[this.gridData.length-1]);
          }
          this.clearAllEdition();
        }
      }
      this.gridReady = true;
    },

    scopeFromIdChanged: function() {
      if(this.el("scopeFromId") != null && this.el("scopeFromId").checkValidity()) {
        this.scopeFromDateSelected = false;
        this.scopeFromDate = this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000));
      }
    },

    scopeToIdChanged: function() {
      if(this.el("scopeToId") != null && this.el("scopeToId").checkValidity()) {
        this.scopeToDateSelected = false;
        this.scopeToDate = this.toISOString(new Date(this.scopeToIdEpochSeconds*1000));
      }
    },

    moveScopeLeft: function() {

      let newScopeFromId = Math.max(0, Math.floor((this.scopeFromId - (this.scopeToIdBook - this.scopeFromIdBook + 1)*1000)/1000)*1000);
      let newScopeToId = this.scopeFromId-1;
      if(newScopeFromId != this.scopeFromId) {
        this.scopeFromId = newScopeFromId;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.scopeToId = newScopeToId;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
        if(this.dataUpdateNeeded) {
          this.getData();
        }
      }
    },

    moveScopeRight: function() {
      let newScopeFromId = this.scopeToId + 1;

      let newScopeToId = Math.min(this.pageSensor.lastBook*1000 + this.pageSensor.lastIndex, (this.scopeToIdBook+1)*1000-1 + (this.scopeToIdBook - this.scopeFromIdBook + 1)*1000);

      if(newScopeToId != this.scopeToId) {
        this.scopeFromId = newScopeFromId;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.scopeToId = newScopeToId;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
        if(this.dataUpdateNeeded) {
          this.getData();
        }
      }
    },

    deleteDownload: function() {
      if(this.downloadUri != null) {
        URL.revokeObjectURL(this.downloadUri)
        this.downloadUri = null
      }
    },

    makeDownload: function() {
      let resultStr = "";

      if(this.groupBy != 'default') {

        if(this.downloadFileFormat == ".csv") {
          let rowSeperator = this.downloadRowSeperator.replace("\\n", "\r\n").replace("\\t", "\t");
          let valueSeperator = this.downloadValueSeperator.replace("\\n", "\r\n").replace("\\t", "\t");

          if(this.downloadIncludeHead) {
            this.fields[this.groupBy].forEach(field=> {
              if(resultStr != '') resultStr += valueSeperator;
              if(typeof(field.filter) == "object") {
                resultStr += field.filter.name + "." + field.type
              }
              else if(field.filter == "t") {
                resultStr += "time";
              }
            });
            resultStr += rowSeperator;
          }

          if(this.downloadTimeFormat == "epoch") {
            this.filteredItems.forEach(item => {
              resultStr += item.t;
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  resultStr += valueSeperator + item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              resultStr += rowSeperator;
            });
          }
          else if(this.downloadTimeFormat == "dtstr") {
            this.filteredItems.forEach(item => {
              resultStr += this.toISOString(new Date(item.t*1000));
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  resultStr += valueSeperator + item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              resultStr += rowSeperator;
            });
          }
          else {
            this.filteredItems.forEach(item => {
              resultStr += this.dateToString(new Date(item.t*1000));
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  resultStr += valueSeperator + item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              resultStr += rowSeperator;
            });
          }
        }

        else {
          let result = [];
          if(this.downloadTimeFormat == "epoch") {
            this.filteredItems.forEach(item=> {
              let toAdd = {};
              toAdd.dt = item.t;
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  toAdd[valueName + "_" + typeName] = item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              result.push(toAdd);
            });
          }
          else if(this.downloadTimeFormat == "dtstr") {
            this.filteredItems.forEach(item => {
              let toAdd = {};
              toAdd.dtstr = this.toISOString(new Date(item.t*1000));
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  toAdd[valueName + "_" + typeName] = item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              result.push(toAdd);
            });
          }
          else {
            this.filteredItems.forEach(item => {
              let toAdd = {};
              for(let valueName in this.columns[this.groupBy]) {
                this.columns[this.groupBy][valueName].forEach(typeName => {
                  toAdd[valueName + "_" + typeName] = item.v[this.valueTypeList[typeName].short][this.valuesFilteredIndex[valueName]];
                })
              }
              result.push(toAdd);
            });
          }
          resultStr = (this.downloadTabAndNewLine)? JSON.stringify(result, null, "\t") : JSON.stringify(result);
        }
      }

      else {
        let valueIndexes = [];
        this.valuesFiltered.forEach((value,index) => {
          if(this.columns.default.some(column => {
              return (column == value.name)
            })) {
            valueIndexes.push(index);
          }
        });

        if(this.downloadFileFormat == ".csv") {
          let rowSeperator = this.downloadRowSeperator.replace("\\n", "\r\n").replace("\\t", "\t")
          let valueSeperator = this.downloadValueSeperator.replace("\\n", "\r\n").replace("\\t", "\t")
          if(this.downloadIncludeHead) {
            resultStr += "time";
            valueIndexes.forEach((index, valueIndex) => {
              resultStr += (valueSeperator + this.valuesFiltered[index].name);
            })
            resultStr += rowSeperator;
          }
          if(this.downloadTimeFormat == "epoch") {
            this.filteredItems.forEach(item=> {
              resultStr += item.data.t.seconds;
              valueIndexes.forEach((index, valueIndex) => {
                resultStr += (valueSeperator + item.data.v[index])
              })
              resultStr += rowSeperator;
            });
          }
          else if(this.downloadTimeFormat == "dtstr") {
            this.filteredItems.forEach(item => {
              resultStr += this.toISOString(item.data.t.toDate());
              valueIndexes.forEach((index, valueIndex) => {
                resultStr += (valueSeperator + item.data.v[index])
              })
              resultStr += rowSeperator;
            });
          }
          else {
            this.filteredItems.forEach(item => {
              resultStr += this.dateToString(item.data.t.toDate());
              valueIndexes.forEach((index, valueIndex) => {
                resultStr += (valueSeperator + item.data.v[index])
              })
              resultStr += rowSeperator;
            });
          }
        }
        else {
          let result = [];
          if(this.downloadTimeFormat == "epoch") {
            this.filteredItems.forEach(item=> {
              let toAdd = {};
              toAdd.dt = item.data.t.seconds;
              valueIndexes.forEach((index) => {
                toAdd[this.valuesFiltered[index].name] = item.data.v[index];
              })
              result.push(toAdd);
            });
          }
          else if(this.downloadTimeFormat == "dtstr") {
            this.filteredItems.forEach(item => {
              let toAdd = {};
              toAdd.dtstr = this.toISOString(item.data.t.toDate());
              valueIndexes.forEach((index) => {
                toAdd[this.valuesFiltered[index].name] = item.data.v[index];
              })
              result.push(toAdd);
            });
          }
          else {
            this.filteredItems.forEach(item => {
              let toAdd = {};
              toAdd.dtstr = this.toISOString(item.data.t.toDate());
              valueIndexes.forEach((index) => {
                toAdd[this.valuesFiltered[index].name] = item.data.v[index];
              })
              result.push(toAdd);
            });
          }
          resultStr = (this.downloadTabAndNewLine)? JSON.stringify(result, null, "\t") : JSON.stringify(result);
        }
      }

      this.blob = new Blob([resultStr], {
        type: "text/plain;charset=utf-8"
      });
      this.deleteDownload();
      this.downloadUri = URL.createObjectURL(this.blob);
    },

    downloadFileExtensionOptionsApply: function() {
      this.deleteDownload();
      this.downloadFileExtension = this.downloadFileFormat;
    },

    showDownloadFloat: function() {
      if(!this.filterUsed && this.filteredItems.length == 0) {
        this.filteredItems = this.gridData;
      }
      this.deleteDownload();
      this.showModal("downloadGridFloat");
    },

    sensorGridRefresh: function() {
      if(this.sensorGridRefreshNeeded) {
        this.$root.$emit('bv::refresh::table', 'sensorGrid');
      }
    },

    findBookIncludesDate: function(date) {
      let foundBook = null;
      if(date && (this.pageSensor.lastBook != 0 || this.pageSensor.lastIndex != -1)) {
        let epochSeconds = Math.floor(date.getTime()/1000);
        if(epochSeconds < this.pageSensor.bookInfo[0].from.seconds) {
          foundBook = -1;
        }
        else if(epochSeconds > this.pageSensor.bookInfo[this.pageSensor.lastBook].to.seconds) {
          foundBook = this.pageSensor.lastBook+1;
        }
        else {
          for(let i=0;i<=this.pageSensor.lastBook;i++) {
            if(epochSeconds <= this.pageSensor.bookInfo[i].to.seconds) {
              foundBook = i;
              break;
            }
          }
        }
      }
      return foundBook;
    },

    scopeFromDateInput: function(date) {

      if(date != "") {
        let fromDate = new Date(date);
        let fromId = null;
        let fromIdSameBook = false;

        if(fromDate && (this.pageSensor.lastBook != 0 || this.pageSensor.lastIndex != -1)) {

          let epochSeconds = Math.floor(fromDate.getTime()/1000);
          let foundBook = this.findBookIncludesDate(fromDate);

          if(foundBook != null) {
            if(foundBook < 0) {
              fromId = 0;
              this.scopeFromDateSelected = false;
            }
            else if(foundBook > this.pageSensor.lastBook) {
              fromId = this.sensorRowCount-1;
              this.scopeFromDateSelected = false;
            }
            else {
              if(this.$parent.$parent.pageSensorHistory[foundBook]) {
                let lastIndex = (foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
                for(let i=0;i<=lastIndex;i++) {
                  if(this.$parent.$parent.pageSensorHistory[foundBook].data[""+i].t.seconds >= epochSeconds) {
                    fromId = foundBook*1000 + i;
                    this.scopeFromDateSelected = false;
                    break;
                  }
                }
              }
              else {
                fromId = foundBook*1000;
                this.scopeFromDateSelected = true;
              }
            }
          }
        }

        if(fromId !== null) {
          this.scopeFromId = fromId;
          this.scopeFromDate = this.toISOString(fromDate);
          this.updateSliderValues();
        }
      }
    },

    scopeToDateInput: function(date) {
      if(date != "") {
        let toDate = new Date(date);
        let toId = null;

        if(toDate && (this.pageSensor.lastBook != 0 || this.pageSensor.lastIndex != -1)) {
          let epochSeconds = Math.floor(toDate.getTime()/1000);
          let foundBook = this.findBookIncludesDate(toDate);

          if(foundBook != null) {
            if(foundBook < 0) {
              toId = 0;
              this.scopeToDateSelected = false;
            }
            else if(foundBook > this.pageSensor.lastBook) {
              toId = this.sensorRowCount-1;
              this.scopeToDateSelected = false;
            }
            else {
              if(this.$parent.$parent.pageSensorHistory[foundBook]) {
                let lastIndex = (foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
                for(let i=lastIndex;i>=0;i--) {
                  if(this.$parent.$parent.pageSensorHistory[foundBook].data[""+i].t.seconds <= epochSeconds) {
                    toId = foundBook*1000 + i;
                    this.scopeToDateSelected = false;
                    break;
                  }
                }
              }
              else {
                toId = foundBook*1000 + ((foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999);
                this.scopeToDateSelected = true;
              }
            }
          }
        }
        if(toId !== null) {
          this.scopeToId = toId;
          this.scopeToDate = this.toISOString(toDate);
          this.updateSliderValues();
        }
      }
    },

    previousScopeFromId: function() {

      if(this.scopeFromIdStart != this.scopeFromId) {
        this.scopeFromId = this.scopeFromIdStart;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.updateSliderValues();
      }
      else {
        if(this.scopeFromId >= 1000) {
          this.scopeFromId = this.scopeFromId  - 1000;
          this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
          this.scopeFromDateSelected = false;
          this.updateSliderValues();
        }
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    nextScopeFromId: function() {
      if((this.scopeFromIdStart+1000) < this.scopeToId) {
        this.scopeFromId = this.scopeFromIdStart+1000;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    previusScopeToId: function() {
      if(this.scopeToIdEnd == (this.sensorRowCount-1)) {
        let result = Math.floor(this.scopeToId/1000)*1000-1;
        if(result > 0 && result > this.scopeFromId) {
          this.scopeToId = result;
          this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
          this.scopeToDateSelected = false;
          this.updateSliderValues();
        }
      }
      else {
        let result = this.scopeToIdEnd-1000;
        if(result > 0 && result > this.scopeFromId) {
          this.scopeToId = result;
          this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
          this.scopeToDateSelected = false;
          this.updateSliderValues();
        }
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    nextScopeToId: function() {

      if(this.scopeToId == this.scopeToIdEnd) {
        this.scopeToId = Math.min(this.scopeToIdEnd + 1000, this.sensorRowCount-1);
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
      }
      else {
        this.scopeToId = this.scopeToIdEnd;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    toggleSliderShow: function() {
      if(this.sliderShow) this.sliderShow = false;
      else this.sliderShow = true;
    },

    focusElement: function(id) {
      if(this.el(id)) {
        this.el(id).focus();
      }
    },

    applyDatetime: function(selected) {
      if(selected != "") {
        this.$set(this.filterUi[this.groupBy], "tInput", this.toISOString(new Date(selected)));
        this.doGridRefresh(10);
      }
    },

    applyChanged: function() {

      let oldActive = this.pageDevice.active;
      if(oldActive) {
        db.collection("devices").doc(this.pageDevice.id).update({
          active: false
        })
      }

      this.isUpdating = true;

      let newBooks = {};
      let firstOldBook = Math.floor((this.scopeFromId)/1000);
      let lastOldBook = Math.floor(this.scopeToId/1000);

      let gridDataFiltered = this.gridData.filter(element=>{ return !element.deleted});

      gridDataFiltered.forEach((element,elementIndex) => {
        let oldBook = Math.floor(element.id/1000);
        let oldPos = element.id%1000;
        let newBook = firstOldBook + Math.floor(elementIndex/1000);
        let newPos = elementIndex%1000;
        if(element.edited) {
          this.valuesFiltered.forEach((value, valueIndex) => {
            if(value.type == "boolean" || value.type == "BOOL_VAL") {
              this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos].v[valueIndex] = (this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos].v[valueIndex] === "true" || this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos].v[oldPos] === "1")? true: false;
            }
            else {
              this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos].v[valueIndex] = this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos].v[valueIndex]*1;
            }
          });
        }
        if(typeof(newBooks[newBook]) == "undefined") newBooks[newBook] = { owner: this.pageUser.id };
        newBooks[newBook][newPos] = this.$parent.$parent.pageSensorHistory[oldBook].data[oldPos];
      });

      let pageSensorInfo = {};
      if(gridDataFiltered.length == 0) {
        pageSensorInfo.lastBook = 0;
        pageSensorInfo.lastIndex = -1;
        pageSensorInfo.lastValues = null;
        pageSensorInfo.lastValuesModified = null;
        pageSensorInfo.bookInfo = {};

      }
      else {
        pageSensorInfo.lastBook = firstOldBook + Math.floor((gridDataFiltered.length-1)/1000);
        pageSensorInfo.lastIndex = (gridDataFiltered.length-1)%1000;
        pageSensorInfo.lastValues = newBooks[firstOldBook + Math.floor((gridDataFiltered.length-1)/1000)][(gridDataFiltered.length-1)%1000];
        pageSensorInfo.lastValuesModified = firebase.firestore.Timestamp.now();

        for(let i=firstOldBook;i<=pageSensorInfo.lastBook;i++) {
          if(i==pageSensorInfo.lastBook) {
            pageSensorInfo["bookInfo." + i] = {
              from: newBooks[i][0].t,
              to: newBooks[i][pageSensorInfo.lastIndex].t
            }
          }
          else {
            pageSensorInfo["bookInfo." + i] = {
              from: newBooks[i][0].t,
              to: newBooks[i][999].t
            }
          }
        }
        for(let i=(pageSensorInfo.lastBook+1);i<=lastOldBook;i++) {
          pageSensorInfo["bookInfo." + i] = firebase.firestore.FieldValue.delete();
        }
      }

      this.$log.info("pageSensorInfo", pageSensorInfo);
      this.$log.info("lastOldBook", lastOldBook);

      let batch = db.batch();

      for(let book in newBooks) {
        batch.set(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(book), newBooks[book]);
      }


      for(let i=(pageSensorInfo.lastBook+1);i<=lastOldBook;i++) {
        batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(i+""));
      }

      if(gridDataFiltered.length == 0) {
        batch.delete(db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(0+""));
      }
      batch.update(db.collection("sensors").doc(this.pageSensor.id), pageSensorInfo);

      batch.commit()
      .then(() => {

        for(let i=(pageSensorInfo.lastBook+1);i<=lastOldBook;i++) {
          delete(this.$parent.$parent.pageSensorHistory[i]);
        }

        for(let book in newBooks) {
          this.$parent.$parent.pageSensorHistory[book] = {
            dirty: false,
            data: newBooks[book]
          };
        }

        this.$parent.$parent.makeToast("success", "데이터 저장 완료", "수정된 데이터를 저장했습니다.");

        this.$parent.$parent.resetGrid();

        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: oldActive
          })
        }
        this.isUpdating = false;
      })
      .catch(error => {
        this.makeToast("danger", "데이터 저장중", "데이터 저장 중 에러가 발생했습니다. 에러 내용: " + error, {
          "noAutoHide": true
        });

        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: oldActive
          })
        }

        this.isUpdating = false;
      })
    },

    initScope: function() {

      /*
      pToId: { type: Number, default: null },
      pToBook: { type: Number, default: null },
      pToDateEpoch: { type: Number, default: null },
      pToDate: { type: String, default: "" },
      */


      if(this.pToId != null) {
        if(this.pToId >= this.sensorRowCount) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToId가 너무 큽니다. 범위의 끝을 최대값으로 지정했습니다.");
          this.scopeToId = this.sensorRowCount-1;
        }
        else if(this.pToId < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToId가 음수입니다. 범위의 끝을 0으로 지정했습니다.");
          this.scopeToId = 0;
        }
        else {
          this.scopeToId = this.pToId;
        }
      }
      else if(this.pToBook != null) {
        if(this.pToBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToBook이 너무 큽니다. 범위의 끝을 최대값으로 지정했습니다.");
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
        }
        else if(this.pToBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToBook이 음수입니다. 범위의 끝을 0으로 지정했습니다.");
          this.scopeToId = 0;
        }
        else {
          this.scopeToId = Math.min(this.pToBook*1000+999, this.lastBook*1000 + this.lastIndex);
        }
      }
      else if(this.pToDateEpoch != null) {
        // 2021.06.08 18:41:36 = 1623145296
        let pToDate = new Date(this.pToDateEpoch*1000);
        let foundBook = this.findBookIncludesDate(pToDate);
        // this.$log.info(pToDate, foundBook);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToDateEpoch가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = 0;
          this.scopeToDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
          this.scopeToDateSelected = false;
        }
        else {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = Math.min(foundBook*1000 + 999, this.lastBook*1000 + this.lastIndex);
          this.scopeToDateSelected = true;
        }
      }
      else if(this.pToDate != "") {
        let pToDate = new Date(this.pToDate);
        let foundBook = this.findBookIncludesDate(pToDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToDate 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = 0;
          this.scopeToDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
          this.scopeToDateSelected = false;
        }
        else {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = Math.min(foundBook*1000 + 999, this.lastBook*1000 + this.lastIndex);
          this.scopeToDateSelected = true;
        }
      }

      /*
      pFromId: { type: Number, default: null },
      pFromBook: { type: Number, default: null },
      pFromDateEpoch: { type: Number, default: null },
      pFromDate: { type: String, default: "" },
      */

      if(this.pFromId != null) {
        if(this.pFromId >= this.sensorRowCount) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromId가 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromId = this.sensorRowCount-1;
        }
        else if(this.pFromId < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromId가 음수입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromId = 0;
        }
        else {
          this.scopeFromId = this.pFromId;
        }
      }
      else if(this.pFromBook != null) {
        if(this.pFromBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromBook이 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
        }
        else if(this.pFromBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromBook이 음수입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromId = 0;
        }
        else {
          this.scopeFromId = Math.min(this.pFromBook*1000, this.lastBook*1000 + this.lastIndex);
        }
      }
      else if(this.pFromDateEpoch != null) {
        // 2021.06.08 18:41:36 = 1623145296
        let pFromDate = new Date(this.pFromDateEpoch*1000);
        let foundBook = this.findBookIncludesDate(pFromDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 너무 작습니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = 0;
          this.scopeFromDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
          this.scopeFromDateSelected = false;
        }
        else {
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = foundBook*1000;
          this.scopeFromDateSelected = true;
        }
      }
      else if(this.pFromDate != "") {
        let pFromDate = new Date(this.pFromDate);
        let foundBook = this.findBookIncludesDate(pFromDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 너무 과거입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = 0;
          this.scopeFromDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 데이터 최종 수정일보다 미래입니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
          this.scopeFromDateSelected = false;
        }
        else {
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = foundBook*1000;
          this.scopeFromDateSelected = true;
        }
      }

      if(this.scopeFromId != null && this.scopeToId != null && (this.scopeFromId > this.scopeToId)) {
        this.makeToast("danger", "범위가 잘못되었습니다.", "범위의 시작이 범위의 끝보다 큽니다. 표를 비활성화합니다.");
        this.gridDisabled = true;
      }
      else if(this.scopeFromId == null && this.scopeToId == null) {
        this.scopeFromId = (this.lastBook <= 1)? 0 : (this.lastBook-1)*1000;
        this.scopeToId = this.lastBook*1000 + this.lastIndex;
      }
      else if(this.scopeFromId == null && this.scopeToId != null ) {
        this.scopeFromId = Math.max(0, Math.floor(this.scopeToId/1000)*1000);
      }
      else if(this.scopeToId == null && this.scopeFromId != null ) {
        this.scopeToId = Math.min(this.lastBook*1000 + this.lastIndex, Math.floor(this.scopeFromId/1000)*1000 + 999);
      }
    },

    setAppHeight: function(height, overflowY) {
      /*
        pHeight: { type: String, default: "" },
        pOverflowY: { type: String, default: "" },
      */
      if(height) {
        if(this.isLastCharNumber(height)) {
          this.el("app").style.height = height + "px";
        }
        else {
          this.el("app").style.height = height;
        }
        if(overflowY) {
          this.el("app").style.overflowY = overflowY;
        }
      }
    },

    initDefaultValues: function() {
      /*
      pPresentation: { type: Boolean, default: false },
      pEditControl: { type: Boolean, default: true },
      pScopeControl: { type: Boolean, default: true },
      pSubControl: { type: Boolean, default: true },
      */
      if(this.pPresentation===true) {
        this.showPresentationModeEscapeButton = false;
        this.presentationMode = true;
      }
      if(this.pEditControl===false) {
        this.showEditControl = false;
      }
      if(this.pScopeControl===false) {
        this.showScopeControl = false;
      }
      if(this.pSubControl===false) {
        this.showSubControl = false;
      }
      if(this.pPageControl===false) {
        this.showPageControl = false;
      }
      /*
      pGroupBy: { type: String, default: "" },
      pPerPage: { type: Number, default: null },
      pCurrent: { type: Number, default: null },
      */
      if(this.pGroupBy !="" && this.pGroupBy != "default") {
        this.groupBy = this.pGroupBy;
      }
      if(this.pPerPage !=0 && this.pPerPage > 0) {
        this.perPage = this.pPerPage;
      }
      if(this.pCurrent != null && this.pCurrent > 1) {
        this.currentPage = this.pCurrent;
      }

      /*
      pSortBy: { type: String, default: "" },
      id, data.t, data.v[0]... data.v[0]
      .t, v.a[0], v.m[0]
      pSortDesc: { type: Boolean, default: true },
      if(!this.pSortDesc) {
        this.sortDesc = false;
      }
      */
      if(this.pSortBy != "") {
        this.sortBy = this.pSortBy;
      }

      if(!this.pSortDesc) {
        this.sortDesc = this.pSortDesc;
      }

    },

    init: function() {

      this.initDefaultValues();
      this.setAppHeight(this.pHeight, this.pOverflowY);

      this.valuesFiltered = this.pageSensor.values.filter(element => {
        return !element.hold;
      });
      this.valuesFiltered.forEach((item,index) => {
        this.valuesFilteredIndex[item.name] = index;
        this.valuesFilteredList[item.name] = item;
      });

      this.lastBook = this.pageSensor.lastBook;
      this.lastIndex = this.pageSensor.lastIndex;
      this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate();
      this.lastValues = this.pageSensor.lastValues;
      this.bookInfo = this.pageSensor.bookInfo;

      this.initScope();

      this.updateSliderValues();
      this.updateStep();

      this.isEditable = (this.scopeToId < this.editableMinId)? false: true;

      this.initColumnsOptions();

      this.initColumns();

      this.initFieldsOptions();
      this.initFilterUi();

      this.getData(true);
    },

    restoreOriginallValues(item) {
      if(typeof(item.ov) != "undefined") {
        let values = []
        item.ov.forEach(function(value) {
          values.push(value)
        })
        item.data.v = values
        item.edited = false
      }
    },

    checkOriginalBackup: function(item, position) {
      if(typeof(item.ov) == "undefined") {
        item.ov = []
        item.data.v.forEach(function(val){
          item.ov.push(val)
        })
        if(this.valuesFiltered[position].type != "boolean") {
          item.edited = true
        }
        else if(item.ov[position] != item.data.v[position]) {
          item.edited = true
        }
      }
      else {
        if(item.ov[position] != item.data.v[position]) {
          item.edited = true
        }
      }
    },
    checkEditValue: function(item, position) {
      if(typeof(item.ov) != "undefined") {
        if(!this.el('detailsInput' + item.id + '_' + position).checkValidity()) {
          this.$set(item.data.v, position, item.ov[position])
        }
      }
    },
    // eslint-disable-next-line
    gridRowClass: function(item, type) {
      if(!item) return;
      if(item.deleted) return "deletedTr";
    },

    toggleFilterOn: function() {
      if(this.filterOn) {
        this.filterOn = false
      }
      else {
        /*
        if(this.el('sensorGrid').getElementsByTagName('tbody') && this.el('sensorGrid').getElementsByTagName('tbody').length==1 && this.el('filterTr') && this.el('sensorGrid').getElementsByTagName('tbody')[0].children.length>0) {
          let tdList = this.el('sensorGrid').getElementsByTagName('tbody')[0].children[0].children;
          let targetTdList = this.el('filterTr').children;
          for(let i=0;i<tdList.length;i++) {
            if(i<targetTdList.length) {
              targetTdList[i].style.width = this.width(tdList[i]) + "px";
            }
          }
        }
        else {
          let targetTdList = this.el('filterTr').children;
          for(let i=0;i<targetTdList.length;i++) {
            targetTdList[i].style.width = "auto";
          }
        }
        */
        this.filterOn = true;
      }

    },

    initFilterUi: function() {

      if(this.groupBy == "default") {
        let result = {};
        // this.$log.info(this.columns.default);
        this.columns.default.forEach(column => {
          if(column == "id") {
            result[column + "Input"] = "";
            result[column + "Select"] = "<=";
          }
          else if(column == "time") {
            result["tInput"] = "";
            result["tInputHidden"] = false;
            result["tSelect"] = "before";
          }
          else if(column == "show_details") {
            result["showSelect"] = "all";
          }
          else if(column != "selected") {
            // this.$log.info(column, this.columnsOptions, this.columnsOptions.default[column].index);
            if(this.valuesFiltered[this.columnsOptions.default[column].index].type == "boolean") {
              result[column + "Select"] = "all";
            }
            else {
              result[column + "Input"] = "";
              result[column + "Select"] = "<=";
            }
          }
        });
        // this.$log.info("filterUi", this.groupBy, result);
        this.$set(this.filterUi, this.groupBy, result);
      }

      else {
        let result = {
          "tInput": "",
          "tInputHidden": false,
          "tSelect": "before",
        };
        // this.$log.info(this.columns, this.columnsOptions);
        for(let valueName in this.columns[this.groupBy]) {

          this.columns[this.groupBy][valueName].forEach(typeName => {
            // this.$log.info(this.groupBy, valueName, typeName , this.columnsOptions[this.groupBy][valueName][typeName]);

            if(this.valuesFiltered[this.columnsOptions[this.groupBy][valueName][typeName].index].type == "boolean") {
              result[valueName + typeName + "Select"] = "all";
            }
            else {
              result[valueName + typeName + "Select"] = "<=";
              result[valueName + typeName + "Input"] = "";
            }
          });
        }
        // this.$log.info("filterUi", this.groupBy, result);
        this.$set(this.filterUi, this.groupBy, result);
      }
    },

    initFilter: function() {
      this.filteredItems = [];
      this.initFilterUi();
    },

    gridFilter: function(row, filter) {
      try {
        if(!this.gridReady) return false;

        if(this.groupBy == "default") {

          if(row.id*1 < this.scopeFromId || row.id*1 > this.scopeToId) {
            return false;
          }

          if(!this.filterOn) return true;

          if(this.filterUi[this.groupBy].showSelect != "all") {
            if(this.filterUi[this.groupBy].showSelect == "deleted") {
              if(!row.deleted) return false;
            }
            else if(this.filterUi[this.groupBy].showSelect == "edited") {
              if(!row.edited || row.deleted) return false;
            }
            else if(this.filterUi[this.groupBy].showSelect == "changed") {
              if(!row.edited && !row.deleted) return false;
            }
            else if(this.filterUi[this.groupBy].showSelect == "unchanged") {
              if(row.edited || row.deleted) return false;
            }
          }

          for(let i=0;i<this.columns.default.length;i++) {

            if(this.columns.default[i] == "id") {
              if(this.filterUi[this.groupBy].idInput != "") {
                switch(this.filterUi[this.groupBy].idSelect) {
                  case "<=":
                  if(this.filterUi[this.groupBy].idInput*1 > row.id*1) return false;
                  break;
                  case "<":
                  if(this.filterUi[this.groupBy].idInput*1 >= row.id*1) return false;
                  break;
                  case "==":
                  if(this.filterUi[this.groupBy].idInput*1 != row.id*1) return false;
                  break;
                  case ">":
                  if(this.filterUi[this.groupBy].idInput*1 <= row.id*1) return false;
                  break;
                  case ">=":
                  if(this.filterUi[this.groupBy].idInput*1 < row.id*1) return false;
                  break;
                  case "!=":
                  if(this.filterUi[this.groupBy].idInput*1 == row.id*1) return false;
                  break;
                }
              }
            }

            else if(this.columns.default[i] == "time") {
              let rowTime = row.data.t.toDate();
              if(this.filterUi[this.groupBy].tInput != "") {
                let inputTime = new Date(this.filterUi[this.groupBy].tInput)
                if(this.filterUi[this.groupBy].tSelect == "before") {
                  if(inputTime.getTime() < rowTime.getTime()) {
                    return false;
                  }
                }
                else if(this.filterUi[this.groupBy].tSelect == "after") {
                  if(inputTime.getTime() > rowTime.getTime()) {
                    return false;
                  }
                }
                else if(this.filterUi[this.groupBy].tSelect == "sameDay") {
                  if(!this.sameDay(inputTime, rowTime)) {
                    return false;
                  }
                }
                else if(this.filterUi[this.groupBy].tSelect == "around") {
                  if(rowTime.getTime() < (inputTime.getTime() - 30*60*1000) || rowTime.getTime() > (inputTime.getTime() + 30*60*1000)) {
                    return false;
                  }
                }
                else if(this.filterUi[this.groupBy].tSelect == "aroundTime") {
                  if(Math.abs(this.getSecondsOfDay(inputTime) - this.getSecondsOfDay(rowTime)) > 30*60) {
                    return false;
                  }
                }
              }
              if(this.filterUi[this.groupBy].tSelect == "am") {
                if(!this.isAM(rowTime)) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "pm") {
                if(!this.isPM(rowTime)) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "day") {
                if(!this.isDay(rowTime)) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "night") {
                if(!this.isNight(rowTime)) {
                  return false;
                }
              }
            }

            else if(this.columns.default[i] != "show_details" && this.columns.default[i] != "selected") {

              if(this.valuesFilteredList[this.columns.default[i]].type == "boolean" || this.valuesFilteredList[this.columns.default[i]].type == "BOOL_VAL") {
                if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] != "all") {
                  if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "true") {
                    if(!row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "false") {
                    if(row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                }
              }
              else {
                if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"] != "") {

                  if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "<=") {

                    // this.$log.info(this.filterUi[this.columns.default[i] + "Input"]*1, this.columns.default[i], this.valuesFilteredList[this.columns.default[i]], row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]);

                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 > row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }

                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "<") {
                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 >= row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "==") {
                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 != row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == ">") {
                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 <= row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == ">=") {
                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 < row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][this.columns.default[i] + "Select"] == "!=") {
                    if(this.filterUi[this.groupBy][this.columns.default[i] + "Input"]*1 == row.data.v[this.valuesFilteredIndex[this.columns.default[i]]]) {
                      return false;
                    }
                  }
                }
              }
            }
          }
        }
        else {

          if(row.t < this.scopeFromDateEpochSeconds) {
            return false;
          }
          if(row.t > this.scopeToDateEpochSeconds) {
            return false;
          }

          if(!this.filterOn) return true;

          if(this.filterOn) {

            for(let valueName in this.columns[this.groupBy]) {
              for(let i=0;i<this.columns[this.groupBy][valueName].length;i++) {

                if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"] != "") {
                  if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == "<=") {

                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 > row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == "<") {
                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 >= row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == "==") {
                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 != row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == ">") {
                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 <= row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == ">=") {
                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 < row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                  else if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Select"] == "!=") {
                    if(this.filterUi[this.groupBy][valueName + this.columns[this.groupBy][valueName][i] + "Input"]*1 == row.v[this.valueTypeList[this.columns[this.groupBy][valueName][i]].short][this.columnsOptions[this.groupBy][valueName][this.columns[this.groupBy][valueName][i]].index]) {
                      return false;
                    }
                  }
                }


              }
            }

            let rowTime = new Date(row.t*1000);
            if(this.filterUi[this.groupBy].tInput != "") {
              let inputTime = new Date(this.filterUi[this.groupBy].tInput);
              if(this.filterUi[this.groupBy].tSelect == "before") {
                if(inputTime.getTime() < rowTime.getTime()) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "after") {
                if(inputTime.getTime() > rowTime.getTime()) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "sameDay") {
                if(!this.sameDay(inputTime, rowTime)) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "around") {
                if(rowTime.getTime() < (inputTime.getTime() - 30*60*1000) || rowTime.getTime() > (inputTime.getTime() + 30*60*1000)) {
                  return false;
                }
              }
              else if(this.filterUi[this.groupBy].tSelect == "aroundTime") {
                if(Math.abs(this.getSecondsOfDay(inputTime) - this.getSecondsOfDay(rowTime)) > 30*60) {
                  return false;
                }
              }
            }

            if(this.filterUi[this.groupBy].tSelect == "am") {
              if(!this.isAM(rowTime)) {
                return false;
              }
            }
            else if(this.filterUi[this.groupBy].tSelect == "pm") {
              if(!this.isPM(rowTime)) {
                return false;
              }
            }
            else if(this.filterUi[this.groupBy].tSelect == "day") {
              if(!this.isDay(rowTime)) {
                return false;
              }
            }
            else if(this.filterUi[this.groupBy].tSelect == "night") {
              if(!this.isNight(rowTime)) {
                return false;
              }
            }
          }
        }
        return true;
      }
      catch(error) {
        return false;
      }
    },

    gridFiltered: function(filteredItems) {
      this.currentPage = 1;
      this.filteredItems = filteredItems;
      // this.$log.info("gridFiltered.length", filteredItems.length);
    },

    cancelScopeChanged: function() {
      this.scopeFromId = this.oldScopeFromId;

      this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
      this.scopeFromDateSelected = false;

      this.scopeToId = this.oldScopeToId;
      this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
      this.scopeToDateSelected = false;

      this.updateSliderValues();
      this.updateStep();
    },

    applyScopeChanged: function() {

      if(this.el("scopeFromId") != null && !this.el("scopeFromId").checkValidity()) {
        if(this.el("scopeFromId")) {
          this.el("scopeFromId").focus();
        }
        return;
      }
      else if(this.el("scopeToId") != null && !this.el("scopeToId").checkValidity()) {
        if(this.el("scopeToId")) {
          this.el("scopeToId").focus();
        }
        return;
      }
      else {

        this.isEditable = (this.sliderValues.length == 0 || (this.sliderValues.length == 2 && this.sliderValues[1] < this.editableMinId))? false : true;

        this.clearAllEdition();
        this.getData(false);
      }
    },

    clearDeletion: function() {
      this.sensorData.forEach(item => {
        item.deleted = false
      })
    },

    clearAllEdition: function() {
      this.sensorData.forEach(item => {
        if(item.deleted) item.deleted = false;
        if(item.selected) item.selected = false;
        if(item.edited) {
          if(typeof(item.ov) != "undefined") {
            item.data.v = item.ov;
            delete(item.ov);
          }
          item.edited = false;
        }
      });
    },

    clearEdition: function() {
      this.sensorData.forEach(item => {
        if(item.edited) {
          if(typeof(item.ov) != "undefined") {
            item.data.v = item.ov
            delete(item.ov)
          }
          item.edited = false
        }
      });
    },

    clearDeletionRow: function(item) {
      item.deleted = false
    },

    clearSelection: function() {
      this.sensorData.forEach(item => {
        item.selected = false
      })
    },

    selectAll: function() {
      let target;
      if(this.isFiltered) {
        target = this.filteredItems;
      }
      else {
        if(this.filteredItems.length == 0) {
          target = this.sensorData;
        }
        else {
          target = this.filteredItems;
        }
      }
      for(let i=0;(i<this.perPage)&&(i<target.length);i++) {
        target[target.length-1-i].selected = true;
      }
    },

    deleteSelection: function() {
      this.sensorData.forEach(item => {
        if(item.selected) {
          item.deleted = true
          item.selected = false
        }
      })
    },

    gridRowSelected: function(items) {
      items.forEach(item => {
        if(!item.deleted) {
          item.selected = true
        }
        else {
          item.selected = false
        }
      })
    },

    getData: function(forced = false) {

      this.gridReady = false;
      if(this.scopeFromId != null && this.scopeToId != null) {
        let firstBook, lastBook;
        firstBook = Math.floor((this.scopeFromId)/1000);
        lastBook = Math.floor(this.scopeToId/1000);
        let toRequest = [];
        for(let i=firstBook;i<=lastBook;i++) {
          if(typeof(this.$parent.$parent.pageSensorHistory[i]) == "undefined") toRequest.push(i);
          else if(this.$parent.$parent.pageSensorHistory[i].dirty) toRequest.push(i);
        }

        if(toRequest.length != 0) {
          let successCount = 0
          toRequest.forEach((item) => {
            db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
            .get()
            .then(book => {
              if(book.exists) {
                this.$parent.$parent.pageSensorHistory[item] = {
                  dirty: false,
                  data: book.data()
                };
                if(++successCount == toRequest.length) this.processData(forced);
              }
              else {
                if(item == 0) this.makeToast("info", "데이터 조회중", "데이터가 없습니다.");
                else this.makeToast("info", "데이터 조회중", item + "번 묶음 데이터가 없습니다.");
              }
            })
            .catch(error => {
              this.makeToast("danger", "데이터 조회중", "데이터 조회 중 에러가 발생했습니다. 에러 내용:" + error);
            })
          })
        }
        else {
          this.processData(forced);
        }
      }
    },

    createGroupByData: function(sorce, groupBy) {
      if(typeof(source) == "undefined") {
        var source = this.sensorData;
      }
      if(typeof(groupBy) == "undefined") {
        var groupBy = this.groupBy;
      }

      let perDiffs = [];
      this.valuesFiltered.forEach((value,index)=> {
        perDiffs.push((value.type == "FLOAT_VAL")? Math.floor(Math.log10((value.diff)? 1/value.diff: 1/0.01)) : null);
      });

      let groupByResult = {};
      if(groupBy == "hour") {
        source.forEach(item=> {
          let itemDate = item.data.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);
          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.data.v[index]);
          });
        })
      }
      else if(groupBy == "date") {
        source.forEach(item=> {
          let itemDate = item.data.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          itemDate.setHours(0);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);
          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.data.v[index]);
          });
        })
      }
      else if(groupBy == "month") {
        source.forEach(item=> {
          let itemDate = item.data.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          itemDate.setHours(0);
          itemDate.setDate(1);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);
          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.data.v[index]);
          });
        })
      }

      let groupByMethodResult = [];
      const arraySum = (accumulator, curr) => accumulator + curr;
      for(let dt in groupByResult) {
        let toAdd = {
          t: dt*1,
          v: {
            x: [], // max
            n: [], // min
            a: [], // average
            m: [], // median
            s: [], // sum
            c: []  // count
          }
        };
        this.valuesFiltered.forEach((value,index)=> {
          groupByResult[dt][index].sort();
          if(perDiffs[index] != null) {
            if(groupByResult[dt][index].length > 0) {
              toAdd.v.n.push(groupByResult[dt][index][0]);
              toAdd.v.x.push(groupByResult[dt][index][groupByResult[dt][index].length-1]);
            }
            if(groupByResult[dt][index].length == 1) {
              toAdd.v.m.push(groupByResult[dt][index][0]);
            }
            else if(groupByResult[dt][index].length%2 == 0) {
              let half = groupByResult[dt][index].length/2;
              toAdd.v.m.push(this.roundValue((groupByResult[dt][index][half-1] + groupByResult[dt][index][half])/2, perDiffs[index]));
            }
            else {
              let half = Math.floor(groupByResult[dt][index].length/2);
              toAdd.v.m.push(groupByResult[dt][index][half]);
            }
            let sum = groupByResult[dt][index].reduce(arraySum);
            toAdd.v.c.push(groupByResult[dt][index].length);
            toAdd.v.s.push(this.roundValue(sum, perDiffs[index]));
            toAdd.v.a.push(this.roundValue(sum/groupByResult[dt][index].length, perDiffs[index]));
          }
          else {
            if(groupByResult[dt][index].length > 0) {
              toAdd.v.n.push(groupByResult[dt][index][0]);
              toAdd.v.x.push(groupByResult[dt][index][groupByResult[dt][index].length-1]);
            }
            if(groupByResult[dt][index].length == 1) {
              toAdd.v.m.push(groupByResult[dt][index][0]);
            }
            else if(groupByResult[dt][index].length%2 == 0) {
              let half = groupByResult[dt][index].length/2;
              toAdd.v.m.push((groupByResult[dt][index][half-1] + groupByResult[dt][index][half])/2);
            }
            else {
              let half = Math.floor(groupByResult[dt][index].length/2);
              toAdd.v.m.push(groupByResult[dt][index][half]);
            }
            let sum = groupByResult[dt][index].reduce(arraySum);
            toAdd.v.c.push(groupByResult[dt][index].length);
            toAdd.v.s.push(sum);
            toAdd.v.a.push(sum/groupByResult[dt][index].length);
          }

        });
        groupByMethodResult.push(toAdd);
      }
      return groupByMethodResult;
    },

    processData: function(forced = false) {

      this.gridReady = false;

      if(this.scopeFromDateSelected) {
        if(typeof(this.$parent.$parent.pageSensorHistory[this.scopeFromIdBook]) != "undefined") {
          let found = null;
          let endIndex = (this.scopeFromIdBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
          for(let startIndex = this.scopeFromId%1000;startIndex<=endIndex;startIndex++) {
            if(this.scopeFromDateEpochSeconds <= this.$parent.$parent.pageSensorHistory[this.scopeFromIdBook].data[startIndex].t.seconds) {
              found = startIndex;
              break;
            }
          }
          if(found != null) {
            this.scopeFromId = (this.scopeFromIdBook*1000)+found ;
            this.scopeFromDateSelected = false;
            this.scopeFromDate = this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000));
          }
        }
      }

      if(this.scopeToDateSelected) {
        if(typeof(this.$parent.$parent.pageSensorHistory[this.scopeToIdBook]) != "undefined") {
          let found = null;

          let startIndex = this.scopeToId%1000;

          for(let endIndex = (this.scopeToIdBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999; endIndex>= 0;endIndex--) {
            if(this.scopeToDateEpochSeconds <= this.$parent.$parent.pageSensorHistory[this.scopeToIdBook].data[endIndex].t.seconds) {
              found = endIndex;
            }
          }
          if(found != null) {
            this.scopeToId = (this.scopeToIdBook*1000) + found;
            this.scopeToDateSelected = false;
            this.scopeToDate = this.toISOString(new Date(this.scopeToIdEpochSeconds*1000));
          }
        }
      }

      let resetNeeded = (!forced && this.oldScopeFromId != null && this.oldScopeToId != null && (this.oldScopeFromId < this.scopeToId) && (this.oldScopeToId > this.scopeFromId) && ((this.oldScopeToId - this.oldScopeFromId + 1)>3000 && ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1)/2) || (this.oldScopeToId - this.oldScopeFromId + 1)>50000 && ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1)/1.5) || (this.oldScopeToId - this.oldScopeFromId + 1)>100000 && ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1))))? false : true;

      if(forced || resetNeeded || (this.groupBy != 'default') && (this.groupByData[this.groupBy].length == 0)) {

        this.sensorData = [];
        this.groupByData = {
          "hour": [],
          "date": [],
          "month": []
        };
        for(let i=this.scopeFromIdBook;i<=this.scopeToIdBook;i++) {
          if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
            let endIndex = (i == this.lastBook)? this.pageSensor.lastIndex: 999;
            for(let j=0;j<=endIndex;j++) {
              this.sensorData.push({
                id: i*1000+j,
                selected: false,
                deleted: false,
                edited: false,
                data: this.$parent.$parent.pageSensorHistory[i].data[j]
              });
            }
          }
        }
        this.valuesFiltered.forEach((value,index)=> {
          if(value.type == "FLOAT_VAL") {
            let perDiff = Math.floor(Math.log10((value.diff)? 1/value.diff: 1/0.01));
            this.sensorData.forEach((item)=> {
              item.data.v[index] = this.roundValue(item.data.v[index], perDiff);
            })
          }
        });

        if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)]) != "undefined") {
          this.scopeFromDate = this.toISOString(new Date(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)].t.seconds*1000));
        }

        if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)]) != "undefined") {
          this.scopeToDate = this.toISOString(new Date(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)].t.seconds*1000));
        }

        if(this.groupBy != "default") {
          this.groupByData[this.groupBy] = this.createGroupByData();
        }

      }
      else {
        let newFrom = [];
        if(this.oldScopeFromId > this.scopeFromId) {
          let endBook = Math.floor((this.oldScopeFromId-1)/1000);
          for(let i=this.scopeFromIdBook;i<=endBook;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
              let startIndex = 0;
              let endIndex = 999;
              if(i == this.scopeFromIdBook) {
                startIndex = this.scopeFromId%1000;
              }
              if(i == endBook) {
                endIndex = (this.oldScopeFromId-1)%1000;
              }

              if(i == this.lastBook) {
                endIndex = Math.min(endIndex, this.pageSensor.lastIndex);
              }

              for(let j=startIndex;j<=endIndex;j++) {
                newFrom.push({
                  id: i*1000+j,
                  selected: false,
                  deleted: false,
                  edited: false,
                  data: this.$parent.$parent.pageSensorHistory[i].data[j]
                });
              }
            }
          }
        }
        let newTo = [];
        if(this.scopeToId > this.oldScopeToId) {
          let startBook = Math.floor((this.oldScopeToId+1)/1000);
          for(let i=startBook;i<=this.scopeToIdBook;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
              let startIndex = 0;
              let endIndex = 999;
              if(i == this.startBook) {
                startIndex = (this.oldScopeToId+1)%1000;
              }
              if(i == this.scoopdeToIdBook) {
                endIndex = this.scopeToId%1000;
              }
              if(i == this.lastBook) {
                endIndex = Math.min(endIndex, this.pageSensor.lastIndex);
              }
              for(let j=startIndex;j<=endIndex;j++) {
                newTo.push({
                  id: i*1000+j,
                  selected: false,
                  deleted: false,
                  edited: false,
                  data: this.$parent.$parent.pageSensorHistory[i].data[j]
                });
              }
            }
          }
        }
        this.valuesFiltered.forEach((value,index)=> {
          if(value.type == "FLOAT_VAL") {
            let perDiff = Math.floor(Math.log10((value.diff)? 1/value.diff: 1/0.01));
            newFrom.forEach((item)=> {
              item.data.v[index] = this.roundValue(item.data.v[index], perDiff);
            })
            newTo.forEach((item)=> {
              item.data.v[index] = this.roundValue(item.data.v[index], perDiff);
            })
          }
        });
        if(newFrom.length != 0) {
          this.sensorData.unshift(...newFrom);
        }
        if(newTo.length != 0) {
          this.sensorData.push(...newTo);
        }

        this.groupByData.hour = [];
        this.groupByData.date = [];
        this.groupByData.month = [];
        if(this.groupBy != "default") {
          this.groupByData[this.groupBy] = this.createGroupByData();
        }

        if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)]) != "undefined") {
          this.scopeFromDate = this.toISOString(new Date(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)].t.seconds*1000));
        }

        if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)]) != "undefined") {
          this.scopeToDate = this.toISOString(new Date(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)].t.seconds*1000));
        }
      }

      if(this.groupBy != "default") {
        this.clearAllEdition();
        this.gridData = this.groupByData[this.groupBy];
      }
      else {
        this.clearAllEdition();
        this.gridData = this.sensorData;
      }

      this.isEditable = (this.scopeToId < this.editableMinId)? false: true;
      this.gridReady = true;

      if(this.gridData.length !=0) {
        this.$set(this.gridData, this.gridData.length-1, this.gridData[this.gridData.length-1]);
      }

      if(this.sliderValues.length == 2) {
        this.$set(this.sliderValues, 0, this.scopeFromIdStart-1);
        this.$set(this.sliderValues, 1, this.scopeToIdEnd);
      }
      else if(this.sliderValues.length ==0) {
        this.sliderValues.push(this.scopeFromIdStart-1);
        this.sliderValues.push(this.scopeToIdEnd);
      }
    },

    checkSliderValues: function(evt) {
      if(evt[0] < evt[1]) {
        let newValue = [evt[0], evt[1]];
        if(newValue[1] > this.rowCount) {
          newValue[1] = (this.rowCount -1);
        }
        else if(newValue[1] > this.lastBook*1000) {
          newValue[1] = (this.rowCount -1);
        }
        if((newValue[0]%1000) != 999) {
          newValue[0] = -1;
        }
        if(newValue[0] == newValue[1]) {
          newValue[1] = Math.min(newValue[0]+1000, this.rowCount-1);
        }
        if(newValue[0] != evt[0] || newValue[1] != evt[1]) {
          this.sliderValues = newValue;
          this.$set(this.sliderValues, 0, newValue[0]);
          this.$set(this.sliderValues, 1, newValue[1]);
        }
        this.scopeFromId = newValue[0] + 1;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.scopeToId = newValue[1];
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
      }
    },
    getLabel: function(value) {
      if(this.sliderStep.length > 20) {
        if(((value+1)/1000)%this.showLabelPer == 0) {
          return ((value+1)%1000 == 0)? ((value+1)/1000).toLocaleString("ko-KR") + "K" : value.toLocaleString("ko-KR");
        }
        else {
          return "";
        }
      }
      else {
        return (value == (this.pageSensor.lastBook*1000+this.pageSensor.lastIndex))? value.toLocaleString("ko-KR") : (value+1).toLocaleString("ko-KR");
      }
    },
    getDateRow: function(value) {
      if(this.scopeFromId == null || this.scopeToId == null) return "";
      else if(this.lastValues == null) return "";
      // lastItem
      else if(value == (this.pageSensor.lastBook*1000+this.pageSensor.lastIndex)) {
        return this.dateToString(this.lastValues.t.toDate(), "/", "\n", ":");
      }
      // ~ value(999)
      else if(value == this.scopeToId) {
        let book = parseInt(value/1000);
        let bookInfoLength = this.countAttributes(this.bookInfo);
        if(book<bookInfoLength) return this.dateToString(this.bookInfo[book].to.toDate(), "/", "\n", ":");
      }
      // value(999)~
      else {
        let book = parseInt((value+1)/1000);
        let bookInfoLength = this.countAttributes(this.bookInfo);
        if(book<bookInfoLength) return this.dateToString(this.bookInfo[book].from.toDate(), "/", "\n", ":");
      }
      return "";
    },

    updateSliderValues: function() {
      if(this.scopeToId > this.scopeFromId) {
        if(this.sliderValues.length == 0) {
          this.sliderValues.push(Math.floor(this.scopeFromId/1000)*1000 -1);
          if(this.scopeToId == (this.sensorRowCount-1)) {
            this.sliderValues.push(this.scopeToId);
          }
          else {
            this.sliderValues.push((Math.floor(this.scopeToId/1000)+1)*1000-1);
          }
        }
        else if(this.sliderValues.length == 2) {
          this.$set(this.sliderValues, 0, Math.floor(this.scopeFromId/1000)*1000 -1);
          if(this.scopeToId == (this.sensorRowCount-1)) {
            this.$set(this.sliderValues, 1, this.scopeToId);
          }
          else {
            this.$set(this.sliderValues, 1, (Math.floor(this.scopeToId/1000)+1)*1000-1);
          }
        }
      }
      if(this.dataUpdateNeeded) {
        window.setTimeout(() => {
          if(this.el("applyScopeChangedButton")) {
            this.el("applyScopeChangedButton").focus();
          }
        }, 100);
      }
    },

    updateStep: function() {
      let result = [];
      let maxBook = Math.floor(this.rowCount/1000);
      for(let i=0;i<=maxBook;i++) {
        result.push(i*1000-1);
      }
      result.push(this.rowCount-1);
      this.sliderStep = result;
    },
  },
  computed: {

    fullURL: function() {

      let result = window.location.protocol;
      result += "//";
      result += window.location.host;
      result += window.location.pathname;
      result += "?mode=grid&pFromId=" + this.scopeFromId;
      if(this.scopeToId != (this.sensorRowCount-1)) {
        result += "&pToId=" + this.scopeToId;
      }
      result += "&pPresentation=" + ((this.presentationMode)?1:0);
      result += "&pScopeControl=1";
      result += "&pSubControl=1";
      result += "&pPageControl=1";
      result += "&pHeight=";
      result += "&pOverflowY=";
      result += "&pGroupBy=" + this.groupBy;

      if(this.groupBy=="default") {
        result+= "&pColumns=" + encodeURIComponent(this.columns.default.join("+"));
      }
      else {
        let tempStr = "";
        for(let valueName in this.columns[this.groupBy]) {
          this.columns[this.groupBy][valueName].forEach(typeName => {
            if(tempStr != "") tempStr += "+";
            tempStr += valueName + "." + typeName;
          })
        }
        if(tempStr != "") result += "&pColumns=" + encodeURIComponent(tempStr);
      }

      result += "&pPerPage=" + this.perPage;
      result += "&pCurrent=" + this.currentPage;
      result += "&pSortBy=" + encodeURIComponent(this.sortBy);
      result += "&pSortDesc=" + ((this.sortDesc)?1:0);
      return result;
    },

    gridFilterOption: function() {
      if(this.filterOn) {
        /*
        let forms = this.el("filterTr").getElementsByTagName("form")
        for(let i=0;i<forms.length;i++) {
          if(!forms[i].reportValidity()) {
            // console.log(null);
            return null;
          }
        }
        */
        return "true";
      }
      else {
        if(this.sensorGridRefreshNeeded) {
          // console.log("true");
          return "true";
        }
        else {
          // console.log(null);
          return null;
        }
      }
    },

    showLabelPer: function() {
      return Math.floor(this.sliderStep.length/((window.innerWidth>1200)?40:20));
    },
    downloadFileName: function() {
      let result = this.pageSensor.name + "_" + this.scopeFromId + "_" + this.scopeToId ;
      if(this.groupBy != 'default') {
        result += "_g";
      }
      if(this.isFiltered) {
        result += "_f";
      }
      return result;
    },

    isFiltered: function() {
      let result = false;

      // console.log(this.filterUi[this.groupBy]);

      for(let ui in this.filterUi[this.groupBy]) {
        if(ui == "tSelect") {
          if(this.filterUi[this.groupBy][ui] == "am" || this.filterUi[this.groupBy][ui] == "pm" || this.filterUi[this.groupBy][ui] == "day" || this.filterUi[this.groupBy][ui] == "night") {
            result = true;
            break;
          }
          else {
            if(this.filterUi[this.groupBy]["tInput"] != "") {
              result = true;
              break;
            }
          }
        }
        else if(ui != "tInput" && ui.endsWith("Input")) {

          if(this.filterUi[this.groupBy][ui] != "") {
            result = true;
            break;
          }
        }
      }
      return result;
    },

    editableMinId: function() {
      if(parseInt(this.lastBook-1)*1000 > 0) {
        return parseInt(this.lastBook-1)*1000;
      }
      else {
        return false;
      }
    },

    minFromDate: function() {
      return (this.pageSensor.bookInfo["0"])? this.toISOString(this.pageSensor.bookInfo["0"].from.toDate()): this.toISOString(new Date(1));
    },
    maxFromDate: function() {
      if(this.pageSensor.bookInfo[this.pageSensor.lastBook +""]) {
        if(this.scopeToIdEpochSeconds) {
          return this.toISOString(new Date(Math.min(this.scopeToIdEpochSeconds, this.pageSensor.bookInfo[this.pageSensor.lastBook +""].from.seconds)*1000));
        }
        else {
          return this.toISOString(this.pageSensor.bookInfo[this.pageSensor.lastBook +""].to.toDate());
        }
      }
      else {
        return this.toISOString(new Date(1));
      }
    },

    minToDate: function() {
      if(this.pageSensor.bookInfo["0"]) {
        return (this.scopeFromIdEpochSeconds)? this.toISOString(new Date(Math.max(this.scopeFromIdEpochSeconds, this.pageSensor.bookInfo["0"].from.seconds)*1000)) : this.toISOString(this.pageSensor.bookInfo["0"].from.toDate());
      }
      else {
        return this.toISOString(new Date(0));
      }
    },

    maxToDate: function() {
      return (this.pageSensor.bookInfo[this.pageSensor.lastBook +""])? this.toISOString(this.pageSensor.bookInfo[this.pageSensor.lastBook +""].to.toDate()) : this.toISOString(new Date(0));
    },

    filterUsed: function() {
      if(this.scopeFromId > this.oldScopeFromId) return true;
      else if(this.scopeFromTo < this.oldScopeToId) return true;
      else if(this.filterOn) return true;
      else return false;
    },

    sensorGridRefreshNeeded: function() {
      if(this.scopeFromId != this.oldScopeFromId) return true;
      if(this.scopeToId != this.oldScopeToId) return true;
      if(this.scopeFromDateEpochSeconds != this.scopeFromIdEpochSeconds) return true;
      if(this.scopeToDateEpochSeconds != this.scopeToIdEpochSeconds) return true;
      return false;
    },

    dataUpdateNeeded: function() {
      if(this.scopeFromId == null) {
        return false;
      }
      else if(this.scopeToId == null) {
        return false;
      }
      else if(this.scopeFromId < 0) {
        return false;
      }
      else if(this.scopeFromId > Math.min(this.sensorRowCount-1-1, this.scopeToId-1)) {
        return false;
      }
      else if(this.scopeToId < (this.scopeFromId+1)) {
        return false;
      }
      else if(this.scopeToId > (this.sensorRowCount-1)) {
        return false;
      }
      else if(this.scopeFromDateSelected) {
        return true;
      }
      else if(this.scopeToDateSelected) {
        return true;
      }
      else if(this.scopeFromIdStart >= this.oldScopeFromIdStart && this.scopeToIdEnd <= this.oldScopeToIdEnd) {
        return false;
      }
      else {
        return true;
      }
    },

    scopeToIdDateStr: function() {
      if(this.scopeToId == null || this.scopeToIdEpochSeconds == null) return "";
      else {
        return this.dateToString(new Date(this.scopeToIdEpochSeconds*1000));
      }
    },

    scopeToDateEpochSeconds: function() {
      if(this.scopeToDate == null || this.scopeToDate == "") return null;
      else return Math.floor((new Date(this.scopeToDate)).getTime()/1000);
    },

    scopeToDateStr: function() {
      return (this.scopeToId == null || this.scopeToIdEpochSeconds == null)? "": this.dateToString(new Date(this.scopeToIdEpochSeconds*1000));
    },

    scopeToIdEpochSeconds: function() {
      if(this.scopeToId == null) return null;
      if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+ Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)]) != "undefined") {
        return this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)].t.seconds;
      }
      else {
        if(this.scopeToId == this.scopeToIdEnd) {
          if(typeof(this.pageSensor.bookInfo[this.scopeToIdBook]) != "undefined") {
            return this.pageSensor.bookInfo[this.scopeToIdBook].to.seconds;
          }
        }
      }
      return null;
    },

    scopeToIdBook: function() {
      return (this.scopeToId == null)? null: Math.floor(this.scopeToId/1000);
    },

    scopeFromIdDateStr: function() {
      return (this.scopeFromId == null || this.scopeFromIdEpochSeconds == null)? "" : this.dateToString(new Date(this.scopeFromIdEpochSeconds*1000));
    },

    scopeFromIdEpochSeconds: function() {
      if(this.scopeFromId == null) return null;

      if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)]) != "undefined") {
        return this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)].t.seconds;
      }
      else {
        if(this.scopeFromId == this.scopeFromIdStart) {
          if(typeof(this.pageSensor.bookInfo[this.scopeFromIdBook]) != "undefined") {
            return this.pageSensor.bookInfo[this.scopeFromIdBook].from.seconds;
          }
        }
      }
      return null;
    },

    scopeFromDateEpochSeconds: function() {
      return (this.scopeFromDate == null || this.scopeFromDate == "")? null : Math.floor((new Date(this.scopeFromDate)).getTime()/1000);
    },

    scopeFromDateStr: function() {
      return (this.scopeFromDate == null || this.scopeFromDate == "")? "": this.dateToString((new Date(this.scopeFromDate)));
    },

    scopeToIdStart: function() {
      return (this.scopeToId == null)? null : Math.floor(this.scopeToId/1000)*1000;
    },

    scopeToIdEnd: function() {
      return (this.scopeToId == null)? null: Math.min(Math.floor(this.scopeToId/1000)*1000+999, this.sensorRowCount - 1);
    },

    scopeFromIdStart: function() {
      return (this.scopeFromId == null)? null: Math.floor(this.scopeFromId/1000)*1000;
    },

    scopeFromIdEnd: function() {
      return (this.scopeFromId == null)? null : Math.min(Math.floor(this.scopeFromId/1000)*1000+999, this.sensorRowCount - 1);
    },
    scopeFromIdBook: function() {
      return (this.scopeFromId == null)? null : Math.floor(this.scopeFromId/1000);
    },

    oldScopeFromId: function() {
      return (this.sensorData.length == 0)? null : this.sensorData[0].id;
    },

    oldScopeToId: function() {
      return (this.sensorData.length == 0)? null: this.sensorData[this.sensorData.length-1].id;
    },

    oldScopeToIdEnd: function() {
      return (this.oldScopeToId == null)? null: Math.min(Math.floor(this.oldScopeToId/1000)*1000+999, this.sensorRowCount - 1);
    },

    oldScopeToIdBook: function() {
      if(this.oldScopeToId == null) return null;
      else return Math.floor(this.oldScopeToId/1000);
    },

    oldScopeFromIdStart: function() {
      return (this.oldScopeFromId == null)? null: Math.floor(this.oldScopeFromId/1000)*1000;
    },

    oldScopeFromIdBook: function() {
      return (this.oldScopeFromId == null)? null: Math.floor(this.oldScopeFromId/1000);
    },

    selectedCount: function() {
      return (this.gridData == null)? 0 : this.gridData.filter(item=>{ if(item.selected) return true; else return false}).length;
    },

    deletedCount: function() {
      let count = 0;
      if(this.gridData != null) {
        this.gridData.forEach(item => {
          if(item.deleted) count++;
        })
      }
      return count;
    },

    editedCount: function() {
      let count = 0;
      if(this.gridData != null) {
        this.gridData.forEach(item => {
          if(!item.deleted && item.edited) count++;
        })
      }
      return count;
    },

    changedCount: function() {
      let count = 0;
      if(this.gridData != null) {
        this.gridData.forEach(item => {
          if(item.deleted || item.edited) count++;
        })
      }
      return count;
    },

    rowCount: function() {
      return this.lastBook*1000 + this.lastIndex + 1;
    },

    sensorRowCount: function() {
      return this.pageSensor.lastBook*1000 + this.pageSensor.lastIndex + 1;
    },

    gridRowCount: function() {
      if(this.filterOn || this.sensorGridRefreshNeeded) return this.filteredItems.length;
      else if(this.gridData != null) return this.gridData.length;
      else return 0;
    },
  },
}
</script>

<style>

.notOwner input { background-color : white !important; }
.notOwner select { background-color : white !important; }
.notOwner textarea { background-color : white !important; }

.dataScopeSliderMark { position: absolute; top: 14px; font-size: 0.8rem; transform: translateX(-50%); white-space: nowrap; }

.dataScopeSliderMax { max-width: 100%; margin-left: 2.5%; width: 95%; padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  height: 95px;
}

.dataScopeSlider {
  border: 1px solid red;
  min-width: 500px;
}

.dataScopeSliderSM {
  margin-left: 2.5%;
  width: 312px;
  max-width: 588.98px;
}

.dataScopeSliderMD {
  margin-left: 2.5%;
  width: 624px;
}

.dataScopeSliderLG {
  margin-left: 2.5%;
  width: 936px;
}

.dataScopeToolTip {
  text-align: center;
  font-size: 0.8rem;
  line-height: 120%;
  letter-spacing: -0.5px;
}
.dataScopeSlider .vue-slider-dot-tooltip, .dataScopeSliderMax .vue-slider-dot-tooltip, .dataScopeSliderSM .vue-slider-dot-tooltip, .dataScopeSliderMD .vue-slider-dot-tooltip, .dataScopeSliderLG .vue-slider-dot-tooltip {
  font-size: 0.8rem; line-height: 12px; text-align: center; top: -3px;
  color: #075BB5;
}
.vue-slider-dot {
  color: #075BB5;
}
.vue-slider-mark-active .dataScopeSliderMark {
  font-weight: bold; color: #075BB5;
}
.dataScopeSlider .popover-body, .dataScopeSliderMAX .popover-body, .dataScopeSliderSM .popover-body, .dataScopeSliderMD .popover-body, .dataScopeSliderLG .popover-body { padding : 38px 36px 30px 36px; }

table.b-table[aria-busy='true'] {
  opacity: 0.6;
}

.dataGrid th { padding : 0.2rem 0.05rem 0.2rem 0.05rem; vertical-align: middle; text-align: center; font-size: 0.8rem; font-weight: normal; }
.dataGrid td { padding: 0.2rem 0.05rem 0.2rem 0.05rem;; vertical-align: middle; font-size: 0.8rem; }
.dataGrid td.numberTd, .dataGrid td.intTd, .dataGrid td.booleanTd, .dataGrid td.idTd  { text-align : right; padding : 0.5rem 0.5rem 0.5rem 0.05rem; line-height:100%; }
.dataGrid td.timeTd { padding : 0.1rem 0.1rem 0.1rem 0.1rem; text-align : center; letter-spacing: -1px; word-spacing: -1px; font-size: 0.8rem; line-height:140%; }
.dataGrid td.selectTd { font-weight: bold; line-height:100%; }
.dataGrid td.editTd { text-align: center; padding: 0rem 0rem 0rem 0rem;  line-height:100%; }
.dataGrid tr.deletedTr {
  text-decoration: line-through; color: gray;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button,
input::-webkit-textfield-decoration-container {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  margin: 0;
}

select {
  -moz-appearance: none;
  -webkit-appearance: none;
}

select::-ms-expand {
  display: none;
}

</style>
